// AUTO-GENERATED — metadata only. Article bodies live in /journal-data/<shard>.json
// and load on demand, so a reader downloads one cluster shard instead of all 143 articles.
// GENERATED FILE — rebuilt by journal-build/build-journal.mjs. NOTE: retired sale-collection links were intentionally replaced with /categories and must not come back.

export interface JournalArticleMeta {
  nn: number;
  slug: string;
  title: string;
  description: string;
  cluster: string;
  hero: string | null;
  heroAlt?: string;
  publishedDate?: string;
  schema: string | string[];
  internalLinks: string[];
  cta: string;
  primaryKeyword: string;
  readMinutes: number;
  shard: string;
}

/** Body + in-body images for one article. */
export interface JournalArticleBody {
  slug: string;
  body: string;
  mids: string[];
}

export type JournalArticle = JournalArticleMeta;

export const CLUSTER_ORDER: string[] = [
  "Sizing Guides",
  "Comparisons",
  "Common Mistakes",
  "Style & Authority",
  "Care & Maintenance",
  "Frequently Asked",
  "Color, Material & Textiles",
  "Trends",
  "Care & Logistics",
  "Rooms & Occasions",
  "Materials & Quality"
];

export const JOURNAL_ARTICLES: JournalArticleMeta[] = [
 {
  "nn": 1,
  "slug": "rug-size-guide",
  "title": "What Size Rug Do You Need? The Complete Rug Size Guide for Every Room",
  "description": "Find the right rug size for every room. Standard rug dimensions, sofa and bed placement rules, and a clear size chart for living, dining, and bedrooms.",
  "cluster": "Sizing Guides",
  "hero": "/journal/01-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/area-rugs",
   "/ideas/dining-table-size-guide",
   "/ideas/area-rug-vs-runner-vs-layered-rugs"
  ],
  "cta": "Browse Area Rugs",
  "primaryKeyword": "what size rug for living room",
  "readMinutes": 6,
  "shard": "sizing-guides"
 },
 {
  "nn": 2,
  "slug": "sofa-dimensions-guide",
  "title": "Sofa Dimensions 101: How to Measure Your Space Before You Buy",
  "description": "Standard sofa dimensions, the measurements that matter, and how to make sure your new sofa fits your room — and through the door. A practical guide.",
  "cluster": "Sizing Guides",
  "hero": "/journal/02-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/sofas",
   "/ideas/rug-size-guide",
   "/ideas/sofa-questions-answered"
  ],
  "cta": "Shop Sofas & Sectionals",
  "primaryKeyword": "sofa size guide",
  "readMinutes": 6,
  "shard": "sizing-guides"
 },
 {
  "nn": 3,
  "slug": "dining-table-size-guide",
  "title": "Dining Table Size Guide: How Many Seats, How Much Clearance, What Fits",
  "description": "How many people fit at a 60-inch table? Dining table dimensions, seating capacity, and clearance rules to find a table that truly fits your room.",
  "cluster": "Sizing Guides",
  "hero": "/journal/03-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/dining",
   "/ideas/rug-size-guide"
  ],
  "cta": "Shop Dining",
  "primaryKeyword": "dining table size guide",
  "readMinutes": 5,
  "shard": "sizing-guides"
 },
 {
  "nn": 4,
  "slug": "mattress-buying-guide",
  "title": "Mattress Buying Guide: How to Choose the Right Mattress Online",
  "description": "How to choose a mattress online: firmness by sleep position, mattress types compared, and the questions to ask before you buy — without lying on one.",
  "cluster": "Sizing Guides",
  "hero": "/journal/04-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/mattresses",
   "/category/bedroom",
   "/ideas/mattress-size-chart"
  ],
  "cta": "Shop Mattresses",
  "primaryKeyword": "how to choose a mattress",
  "readMinutes": 6,
  "shard": "sizing-guides"
 },
 {
  "nn": 5,
  "slug": "mattress-size-chart",
  "title": "Mattress Size Chart: Twin to King, Explained",
  "description": "Every standard US mattress size in one chart — twin, full, queen, king, and California king — plus the room size each one needs to fit comfortably.",
  "cluster": "Sizing Guides",
  "hero": "/journal/05-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/mattresses",
   "/category/bedroom",
   "/ideas/mattress-buying-guide"
  ],
  "cta": "Shop Mattresses",
  "primaryKeyword": "mattress size chart",
  "readMinutes": 6,
  "shard": "sizing-guides"
 },
 {
  "nn": 6,
  "slug": "how-to-choose-an-office-chair",
  "title": "How to Choose an Office Chair You Can Actually Sit In All Day",
  "description": "Learn how to choose an office chair you can sit in all day: seat height, depth, lumbar support, and the measurements that matter for home offices.",
  "cluster": "Sizing Guides",
  "hero": "/journal/06-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/office-chairs",
   "/category/office",
   "/ideas/floor-lamp-buying-guide"
  ],
  "cta": "Shop Office Chairs",
  "primaryKeyword": "how to choose an office chair",
  "readMinutes": 6,
  "shard": "sizing-guides"
 },
 {
  "nn": 7,
  "slug": "floor-lamp-buying-guide",
  "title": "Floor Lamp Buying Guide: Height, Light, and Placement",
  "description": "A practical floor lamp buying guide: ideal heights in inches, where to place reading lamps, and how to match lamp scale to your seating and room.",
  "cluster": "Sizing Guides",
  "hero": "/journal/07-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/floor-lamps",
   "/category/lighting",
   "/ideas/layered-lighting-101"
  ],
  "cta": "Shop Floor Lamps",
  "primaryKeyword": "how to choose a floor lamp",
  "readMinutes": 6,
  "shard": "sizing-guides"
 },
 {
  "nn": 8,
  "slug": "outdoor-furniture-materials",
  "title": "Outdoor Furniture Materials: What Actually Survives Sun, Rain, and Winters",
  "description": "Compare the best outdoor furniture materials — teak, aluminum, steel, wicker, and more — and learn what actually survives sun, rain, and winter.",
  "cluster": "Sizing Guides",
  "hero": "/journal/08-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/outdoor",
   "/ideas/outdoor-furniture-care-guide"
  ],
  "cta": "Shop Outdoor",
  "primaryKeyword": "best outdoor furniture materials",
  "readMinutes": 6,
  "shard": "sizing-guides"
 },
 {
  "nn": 9,
  "slug": "how-to-choose-a-bed-frame",
  "title": "How to Choose a Bed Frame: Styles, Materials, and What to Skip",
  "description": "A clear bed frame buying guide: platform vs. panel beds, wood vs. upholstered vs. metal, sizing in inches, and which details are worth skipping.",
  "cluster": "Sizing Guides",
  "hero": "/journal/09-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/bedroom",
   "/category/mattresses",
   "/ideas/platform-bed-vs-box-spring"
  ],
  "cta": "Shop Bedroom",
  "primaryKeyword": "bed frame buying guide",
  "readMinutes": 6,
  "shard": "sizing-guides"
 },
 {
  "nn": 10,
  "slug": "chandelier-size-guide",
  "title": "Chandelier and Ceiling Light Size Guide: Getting Scale Right",
  "description": "Use this chandelier size guide to get diameter, hanging height, and scale right — with simple formulas and tables for dining rooms, entries, and more.",
  "cluster": "Sizing Guides",
  "hero": "/journal/10-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/lighting",
   "/ideas/dining-table-size-guide",
   "/ideas/layered-lighting-101"
  ],
  "cta": "Shop Lighting",
  "primaryKeyword": "chandelier size guide",
  "readMinutes": 6,
  "shard": "sizing-guides"
 },
 {
  "nn": 11,
  "slug": "sectional-vs-sofa",
  "title": "Sectional vs. Sofa: Which Is Right for Your Space?",
  "description": "Sectional or sofa? Compare footprint, seating, layout flexibility, and cost so you can choose the right piece for your living room — with real numbers.",
  "cluster": "Comparisons",
  "hero": "/journal/11-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/sofas",
   "/ideas/sofa-dimensions-guide",
   "/ideas/modern-loft-look"
  ],
  "cta": "Shop Sofas & Sectionals",
  "primaryKeyword": "sectional vs sofa",
  "readMinutes": 6,
  "shard": "comparisons"
 },
 {
  "nn": 12,
  "slug": "wool-vs-jute-vs-synthetic-rugs",
  "title": "Wool vs. Jute vs. Synthetic Rugs: An Honest Comparison",
  "description": "Wool, jute, or synthetic? An honest look at durability, softness, cleaning, and cost — plus which rug fiber fits each room of a real home and lifestyle.",
  "cluster": "Comparisons",
  "hero": "/journal/12-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/area-rugs",
   "/ideas/rug-size-guide"
  ],
  "cta": "Browse Area Rugs",
  "primaryKeyword": "wool vs jute rug",
  "readMinutes": 6,
  "shard": "comparisons"
 },
 {
  "nn": 13,
  "slug": "boucle-vs-linen-vs-performance-fabric",
  "title": "Bouclé vs. Linen vs. Performance Fabric: Choosing Sofa Upholstery",
  "description": "Bouclé, linen, or performance fabric? Compare texture, durability, pet-friendliness, and care so your sofa upholstery fits the way you actually live.",
  "cluster": "Comparisons",
  "hero": "/journal/13-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/sofas",
   "/ideas/how-to-clean-boucle-sofa"
  ],
  "cta": "Shop Sofas",
  "primaryKeyword": "boucle vs linen sofa",
  "readMinutes": 6,
  "shard": "comparisons"
 },
 {
  "nn": 14,
  "slug": "leather-vs-fabric-sofa",
  "title": "Leather vs. Fabric Sofas: Pros, Cons, and Real-Life Durability",
  "description": "Leather or fabric sofa? An honest comparison of durability, comfort, cleaning, cost, and aging — plus how faux leather really holds up over the years.",
  "cluster": "Comparisons",
  "hero": "/journal/14-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/sofas",
   "/ideas/boucle-vs-linen-vs-performance-fabric"
  ],
  "cta": "Shop Sofas",
  "primaryKeyword": "leather vs fabric sofa",
  "readMinutes": 6,
  "shard": "comparisons"
 },
 {
  "nn": 15,
  "slug": "platform-bed-vs-box-spring",
  "title": "Platform Bed vs. Box Spring: What Modern Bedrooms Actually Need",
  "description": "Do you need a box spring with a platform bed? Usually not. Compare support, height, cost, and mattress compatibility before you choose your bed base.",
  "cluster": "Comparisons",
  "hero": "/journal/15-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/bedroom",
   "/ideas/mattress-buying-guide",
   "/ideas/how-to-choose-a-bed-frame"
  ],
  "cta": "Shop Bedroom",
  "primaryKeyword": "platform bed vs box spring",
  "readMinutes": 6,
  "shard": "comparisons"
 },
 {
  "nn": 16,
  "slug": "round-vs-rectangular-dining-table",
  "title": "Round vs. Rectangular Dining Table: How to Decide",
  "description": "Round or rectangular dining table? Compare seating, clearance, and room shape with real measurements so your next table actually fits your space.",
  "cluster": "Comparisons",
  "hero": "/journal/16-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/dining",
   "/ideas/dining-table-size-guide"
  ],
  "cta": "Shop Dining",
  "primaryKeyword": "round vs rectangular dining table",
  "readMinutes": 6,
  "shard": "comparisons"
 },
 {
  "nn": 17,
  "slug": "modular-vs-fixed-sectional",
  "title": "Modular vs. Fixed Sectionals: Flexibility or Stability?",
  "description": "Modular or fixed sectional? Compare flexibility, stability, price, and long-term fit — and find out when a modular sofa is actually worth it.",
  "cluster": "Comparisons",
  "hero": "/journal/17-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/sofas",
   "/ideas/sectional-vs-sofa",
   "/ideas/sofa-dimensions-guide"
  ],
  "cta": "Shop Sectional Seating",
  "primaryKeyword": "modular sectional sofa",
  "readMinutes": 6,
  "shard": "comparisons"
 },
 {
  "nn": 18,
  "slug": "make-modern-home-feel-cozy",
  "title": "How to Make a Modern Space Feel Warmer (Without Adding Clutter)",
  "description": "Modern rooms can read cold fast. Warm yours up without clutter using texture, wood tones, layered lighting, and one well-sized rug — a designer's plan.",
  "cluster": "Comparisons",
  "hero": "/journal/18-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/ideas/warm-minimalism-guide",
   "/category/decor",
   "/category/lighting"
  ],
  "cta": "Explore the Collection",
  "primaryKeyword": "how to make a modern home feel cozy",
  "readMinutes": 6,
  "shard": "comparisons"
 },
 {
  "nn": 19,
  "slug": "living-room-feels-unfinished",
  "title": "Why Your Living Room Feels Unfinished — and the 5 Fixes That Work",
  "description": "If your living room feels unfinished, the cause is usually one of five things. Here's how to fix the rug, lighting, layout, walls, and layers — fast.",
  "cluster": "Comparisons",
  "hero": "/journal/19-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/design-services",
   "/ideas/rug-size-guide",
   "/ideas/layered-lighting-101"
  ],
  "cta": "Get a Free Design Plan",
  "primaryKeyword": "living room feels unfinished",
  "readMinutes": 6,
  "shard": "comparisons"
 },
 {
  "nn": 20,
  "slug": "small-living-room-furniture-arrangement",
  "title": "How to Arrange Furniture in a Small Living Room: Layouts That Work",
  "description": "Arrange furniture in a small living room with real numbers: 30–36 inch walkways, 14–18 inches sofa to coffee table, plus four layouts that work.",
  "cluster": "Comparisons",
  "hero": "/journal/20-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/sofas"
  ],
  "cta": "Shop Compact Furniture",
  "primaryKeyword": "small living room furniture arrangement",
  "readMinutes": 5,
  "shard": "comparisons"
 },
 {
  "nn": 21,
  "slug": "make-rental-feel-like-home",
  "title": "The Renter's Guide to a Home That Feels Permanent",
  "description": "Renting doesn't have to feel temporary. No-drill upgrades, rugs, lighting, and furniture that moves with you — how to make a rental feel like home.",
  "cluster": "Comparisons",
  "hero": "/journal/21-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/decor",
   "/category/area-rugs"
  ],
  "cta": "Shop by Room",
  "primaryKeyword": "how to make a rental feel like home",
  "readMinutes": 6,
  "shard": "comparisons"
 },
 {
  "nn": 22,
  "slug": "zone-open-plan-living-room",
  "title": "Open-Plan Living: How to Zone One Big Room",
  "description": "One big room, no walls? Zone an open floor plan with rugs, lighting, and furniture placement — with the clearances and rug sizes that make it work.",
  "cluster": "Comparisons",
  "hero": "/journal/22-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/ideas/rug-size-guide",
   "/ideas/layered-lighting-101",
   "/category/area-rugs"
  ],
  "cta": "Browse Area Rugs",
  "primaryKeyword": "how to divide open plan living space",
  "readMinutes": 6,
  "shard": "comparisons"
 },
 {
  "nn": 23,
  "slug": "first-apartment-furniture-checklist",
  "title": "Furnishing Your First Apartment: The Complete Checklist (and What to Skip)",
  "description": "A first apartment furniture checklist in buying order: what you need week one, what can wait, what to skip entirely — and how to spend where it counts.",
  "cluster": "Comparisons",
  "hero": "/journal/23-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/design-services",
   "/category/best-sellers"
  ],
  "cta": "Get a Free Design Plan",
  "primaryKeyword": "first apartment furniture checklist",
  "readMinutes": 6,
  "shard": "comparisons"
 },
 {
  "nn": 24,
  "slug": "sofa-buying-mistakes",
  "title": "7 Sofa-Buying Mistakes Designers See All the Time (and How to Avoid Every One)",
  "description": "A sofa is the biggest seat in the house and the easiest one to get wrong. Seven mistakes designers see constantly — and the simple fixes for each.",
  "cluster": "Common Mistakes",
  "hero": "/journal/24-hero.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/sofas",
   "/ideas/sofa-dimensions-guide",
   "/ideas/sectional-vs-sofa",
   "/ideas/boucle-vs-linen-vs-performance-fabric"
  ],
  "cta": "Shop Sofas",
  "primaryKeyword": "sofa buying mistakes",
  "readMinutes": 6,
  "shard": "common-mistakes"
 },
 {
  "nn": 25,
  "slug": "rug-mistakes-rooms-feel-smaller",
  "title": "The Rug Mistakes That Make Rooms Feel Smaller (and How to Fix Each One)",
  "description": "The wrong rug can shrink a room by feet, not inches. Learn the five most common rug mistakes — size, placement, layering — and how to fix each one.",
  "cluster": "Common Mistakes",
  "hero": "/journal/25-hero.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/area-rugs",
   "/ideas/rug-size-guide",
   "/ideas/wool-vs-jute-vs-synthetic-rugs",
   "/ideas/area-rug-vs-runner-vs-layered-rugs"
  ],
  "cta": "Browse Area Rugs",
  "primaryKeyword": "rug mistakes",
  "readMinutes": 5,
  "shard": "common-mistakes"
 },
 {
  "nn": 26,
  "slug": "lighting-mistakes",
  "title": "6 Lighting Mistakes That Flatten Your Room (and the Easy Fixes)",
  "description": "One overhead bulb makes any room feel flat. Six common lighting mistakes — and the simple fixes that add depth, warmth, and dimension to your home.",
  "cluster": "Common Mistakes",
  "hero": "/journal/26-hero.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/lighting",
   "/ideas/floor-lamp-buying-guide",
   "/ideas/layered-lighting-101"
  ],
  "cta": "Shop Lighting",
  "primaryKeyword": "lighting mistakes home",
  "readMinutes": 5,
  "shard": "common-mistakes"
 },
 {
  "nn": 27,
  "slug": "dining-room-mistakes",
  "title": "Dining Room Mistakes That Make Dinners Feel Cramped (and How to Fix Them)",
  "description": "If guests have to shuffle sideways to sit down, the room is telling you something. Six dining room mistakes that cramp dinners — and how to fix them.",
  "cluster": "Common Mistakes",
  "hero": "/journal/27-hero.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/dining",
   "/ideas/dining-table-size-guide",
   "/ideas/round-vs-rectangular-dining-table"
  ],
  "cta": "Shop Dining",
  "primaryKeyword": "dining room design mistakes",
  "readMinutes": 5,
  "shard": "common-mistakes"
 },
 {
  "nn": 28,
  "slug": "warm-minimalism-guide",
  "title": "Warm Minimalism: The Complete Guide to 2026's Defining Interior Trend",
  "description": "Warm minimalism, explained: the principles, palette, and materials behind 2026's defining interior trend — plus room-by-room ways to get the look at home.",
  "cluster": "Style & Authority",
  "hero": "/journal/28-hero.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/ideas/texture-pairing-guide",
   "/category/living",
   "/category/decor",
   "/ideas/make-modern-home-feel-cozy"
  ],
  "cta": "Explore the Collection",
  "primaryKeyword": "warm minimalism",
  "readMinutes": 9,
  "shard": "style-authority"
 },
 {
  "nn": 29,
  "slug": "japandi-style-guide",
  "title": "Japandi Style at Home: Principles, Palette, and Pieces",
  "description": "What japandi style really means: Japanese-Scandinavian principles, a quiet natural palette, and the furniture choices that make it work in real homes.",
  "cluster": "Style & Authority",
  "hero": "/journal/29-hero.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/ideas/warm-minimalism-guide",
   "/ideas/texture-pairing-guide",
   "/category/bedroom",
   "/category/dining"
  ],
  "cta": "Explore the Collection",
  "primaryKeyword": "japandi style",
  "readMinutes": 7,
  "shard": "style-authority"
 },
 {
  "nn": 30,
  "slug": "modern-loft-look",
  "title": "The Modern Loft Look: Industrial Bones, Warm Layers",
  "description": "Loft apartment decor ideas that keep the industrial bones and lose the chill — zoning, warm layers, lighting, and furniture scaled for open space.",
  "cluster": "Style & Authority",
  "hero": "/journal/30-hero.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/living",
   "/category/area-rugs",
   "/ideas/small-living-room-furniture-arrangement",
   "/ideas/zone-open-plan-living-room"
  ],
  "cta": "Shop by Room",
  "primaryKeyword": "loft apartment decor ideas",
  "readMinutes": 7,
  "shard": "style-authority"
 },
 {
  "nn": 31,
  "slug": "layered-lighting-101",
  "title": "Layered Lighting 101: Ambient, Task, and Accent — Explained Simply",
  "description": "Layered lighting, made simple: how ambient, task, and accent light work together, how many sources each room needs, and which bulbs keep it warm.",
  "cluster": "Style & Authority",
  "hero": "/journal/31-hero.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/ideas/floor-lamp-buying-guide",
   "/ideas/chandelier-size-guide",
   "/category/lighting",
   "/category/floor-lamps"
  ],
  "cta": "Shop Lighting",
  "primaryKeyword": "layered lighting",
  "readMinutes": 7,
  "shard": "style-authority"
 },
 {
  "nn": 32,
  "slug": "texture-pairing-guide",
  "title": "The Texture Pairing Guide: Wood, Linen, Stone, and Warm Metal",
  "description": "How to mix textures in interior design: a practical guide to pairing wood, linen, stone, bouclé, and warm metal so neutral rooms feel layered, not flat.",
  "cluster": "Style & Authority",
  "hero": "/journal/32-hero.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/ideas/warm-minimalism-guide",
   "/ideas/japandi-style-guide",
   "/category/area-rugs",
   "/category/decor"
  ],
  "cta": "Explore the Collection",
  "primaryKeyword": "how to mix textures interior design",
  "readMinutes": 7,
  "shard": "style-authority"
 },
 {
  "nn": 33,
  "slug": "how-to-mix-wood-tones",
  "title": "How to Mix Wood Tones Without It Looking Accidental",
  "description": "Yes, you can mix oak, walnut, and darker woods in one room. Learn the dominant-tone rule, undertone matching, and simple fixes that make mixed woods look intentional.",
  "cluster": "Style & Authority",
  "hero": "/journal/33-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/ideas/best-time-to-buy-furniture",
   "/ideas/where-to-splurge-and-where-to-save-on-furniture",
   "/categories"
  ],
  "cta": "Shop Dining / Bookcases",
  "primaryKeyword": "how to mix wood tones",
  "readMinutes": 6,
  "shard": "style-authority"
 },
 {
  "nn": 34,
  "slug": "how-to-clean-boucle-sofa",
  "title": "How to Clean and Care for a Bouclé Sofa",
  "description": "Learn how to clean a bouclé sofa the right way: gentle routine care, safe spot cleaning, snag fixes, and the mistakes that damage looped fabric.",
  "cluster": "Care & Maintenance",
  "hero": "/journal/34-hero.webp",
  "schema": [
   "Article",
   "FAQPage",
   "HowTo (suggested, for the spot-cleaning steps)"
  ],
  "internalLinks": [
   "/category/sofas",
   "/ideas/boucle-vs-linen-vs-performance-fabric",
   "/ideas/sofa-questions-answered"
  ],
  "cta": "Read the Sofa Fabric Guide",
  "primaryKeyword": "how to clean boucle sofa",
  "readMinutes": 6,
  "shard": "care-maintenance"
 },
 {
  "nn": 35,
  "slug": "rug-care-101",
  "title": "Rug Care 101: Keeping Handwoven Rugs Looking New",
  "description": "A practical guide to area rug care: weekly vacuuming, safe spot cleaning, shedding fixes, and a simple seasonal routine to keep wool rugs looking new.",
  "cluster": "Care & Maintenance",
  "hero": "/journal/35-hero.webp",
  "schema": [
   "Article",
   "FAQPage",
   "HowTo (suggested, for the spot-cleaning steps)"
  ],
  "internalLinks": [
   "/category/area-rugs",
   "/ideas/rug-size-guide",
   "/ideas/wool-vs-jute-vs-synthetic-rugs"
  ],
  "cta": "Browse Area Rugs",
  "primaryKeyword": "how to clean an area rug",
  "readMinutes": 5,
  "shard": "care-maintenance"
 },
 {
  "nn": 36,
  "slug": "outdoor-furniture-care-guide",
  "title": "Outdoor Furniture Care: A Season-by-Season Guide",
  "description": "Protect outdoor furniture from sun, rain, and winter with a simple seasonal routine — cleaning, covers, storage, and the mistakes that age patio pieces fastest.",
  "cluster": "Care & Maintenance",
  "hero": "/journal/36-hero.webp",
  "schema": "Article + FAQPage + HowTo",
  "internalLinks": [],
  "cta": "Shop Outdoor",
  "primaryKeyword": "how to protect outdoor furniture",
  "readMinutes": 5,
  "shard": "care-maintenance"
 },
 {
  "nn": 37,
  "slug": "best-sectionals-for-small-spaces",
  "title": "The Best Sectionals for Small Spaces: Our Picks",
  "description": "What makes a sectional work in a small space? We break down sizing, silhouettes, and seven compact sectional profiles for apartments and lofts.",
  "cluster": "Care & Maintenance",
  "hero": "/journal/37-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage",
   "ItemList (suggested — one ListItem per product pick)"
  ],
  "internalLinks": [
   "/category/sofas",
   "/ideas/sectional-vs-sofa",
   "/ideas/small-living-room-furniture-arrangement"
  ],
  "cta": "Shop Sectional Seating",
  "primaryKeyword": "best sectionals for small spaces",
  "readMinutes": 6,
  "shard": "care-maintenance"
 },
 {
  "nn": 38,
  "slug": "best-time-to-buy-furniture",
  "title": "When Is the Best Time to Buy Furniture? A Realistic Deals Calendar",
  "description": "When does furniture actually go on sale? A realistic month-by-month calendar for indoor and outdoor pieces, plus how to shop sales without second-guessing.",
  "cluster": "Care & Maintenance",
  "hero": "/journal/38-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/categories",
   "/category/outdoor"
  ],
  "cta": "Browse the Collections",
  "primaryKeyword": "best time to buy furniture",
  "readMinutes": 6,
  "shard": "care-maintenance"
 },
 {
  "nn": 39,
  "slug": "how-to-buy-furniture-online-with-confidence",
  "title": "How to Buy Furniture Online with Confidence",
  "description": "Buying furniture online doesn't have to be a gamble. A practical checklist for measuring, reading dimensions, checking materials, and vetting return policies.",
  "cluster": "Care & Maintenance",
  "hero": "/journal/39-hero.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/shipping",
   "/returns",
   "/faq",
   "/category/best-sellers"
  ],
  "cta": "Shop Best Sellers",
  "primaryKeyword": "buying furniture online tips",
  "readMinutes": 6,
  "shard": "care-maintenance"
 },
 {
  "nn": 40,
  "slug": "best-rugs-open-plan-space",
  "title": "The Best Rugs to Anchor an Open-Plan Space: Our Picks",
  "description": "The right rug turns one big room into distinct zones. What to look for in a large area rug, plus six picks for anchoring an open floor plan.",
  "cluster": "Care & Maintenance",
  "hero": "/journal/40-hero.webp",
  "schema": [
   "Article",
   "FAQPage",
   "ItemList (suggested — one ListItem per pick)"
  ],
  "internalLinks": [
   "/category/area-rugs",
   "/ideas/rug-size-guide",
   "/ideas/zone-open-plan-living-room"
  ],
  "cta": "Browse Area Rugs",
  "primaryKeyword": "best area rugs living room",
  "readMinutes": 6,
  "shard": "care-maintenance"
 },
 {
  "nn": 41,
  "slug": "furniture-financing-explained",
  "title": "Furniture Financing, Explained Simply",
  "description": "How furniture financing actually works — buy now pay later, 0% APR offers, deferred interest, and the five things to check in any plan before you commit.",
  "cluster": "Care & Maintenance",
  "hero": "/journal/41-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/ideas/best-time-to-buy-furniture",
   "/ideas/where-to-splurge-and-where-to-save-on-furniture",
   "/categories"
  ],
  "cta": "Browse Furniture",
  "primaryKeyword": "furniture financing options",
  "readMinutes": 5,
  "shard": "care-maintenance"
 },
 {
  "nn": 42,
  "slug": "what-is-performance-fabric",
  "title": "What Is Performance Fabric — and When Is It Worth It?",
  "description": "Performance fabric is upholstery engineered to resist stains, fading, and wear. Here's how it works, what it costs you in feel, and when it's worth it.",
  "cluster": "Frequently Asked",
  "hero": "/journal/42-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/sofas",
   "/ideas/boucle-vs-linen-vs-performance-fabric",
   "/ideas/how-to-clean-boucle-sofa"
  ],
  "cta": "Shop Sofas",
  "primaryKeyword": "what is performance fabric",
  "readMinutes": 5,
  "shard": "frequently-asked"
 },
 {
  "nn": 43,
  "slug": "sofa-questions-answered",
  "title": "Sofa Questions, Answered: 15 Things Shoppers Ask Before Buying",
  "description": "How long should a sofa last? What does seat depth mean? Fifteen real questions sofa shoppers ask before buying — answered plainly, with numbers.",
  "cluster": "Frequently Asked",
  "hero": "/journal/43-hero.webp",
  "schema": [
   "FAQPage"
  ],
  "internalLinks": [
   "/category/sofas",
   "/ideas/sofa-dimensions-guide",
   "/ideas/sectional-vs-sofa",
   "/ideas/boucle-vs-linen-vs-performance-fabric",
   "/ideas/sofa-buying-mistakes"
  ],
  "cta": "Shop Sofas",
  "primaryKeyword": "sofa FAQ",
  "readMinutes": 6,
  "shard": "frequently-asked"
 },
 {
  "nn": 44,
  "slug": "how-to-choose-a-coffee-table",
  "title": "How to Choose a Coffee Table: Size, Shape, and Height",
  "description": "A practical coffee table size guide: the right height, width, and distance from your sofa, plus shape rules in inches. Choose one that fits the first time.",
  "cluster": "Frequently Asked",
  "hero": "/journal/44-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/living",
   "/ideas/small-living-room-furniture-arrangement",
   "/ideas/how-to-style-a-coffee-table"
  ],
  "cta": "Shop Living",
  "primaryKeyword": "how to choose a coffee table",
  "readMinutes": 7,
  "shard": "frequently-asked"
 },
 {
  "nn": 45,
  "slug": "how-to-choose-an-accent-chair",
  "title": "How to Choose an Accent Chair: Comfort, Scale, and Style",
  "description": "An accent chair guide covering scale, seat height and depth, reading-chair comfort, and how to place one. Practical numbers in inches to get the fit right.",
  "cluster": "Frequently Asked",
  "hero": "/journal/45-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/living",
   "/ideas/how-to-create-a-reading-nook",
   "/ideas/floor-lamp-buying-guide"
  ],
  "cta": "Shop Living",
  "primaryKeyword": "how to choose an accent chair",
  "readMinutes": 6,
  "shard": "frequently-asked"
 },
 {
  "nn": 46,
  "slug": "console-table-guide",
  "title": "Console Table Guide: Placement, Sizing, and Uses",
  "description": "Where to put a console table, how to size it for an entryway or behind a sofa, and the right height and depth in inches. A practical placement-first guide.",
  "cluster": "Frequently Asked",
  "hero": "/journal/46-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/living",
   "/ideas/entryway-styling-console-mirror-landing-zone",
   "/ideas/how-to-choose-a-coffee-table"
  ],
  "cta": "Shop Living",
  "primaryKeyword": "console table guide",
  "readMinutes": 7,
  "shard": "frequently-asked"
 },
 {
  "nn": 47,
  "slug": "how-to-choose-a-tv-stand",
  "title": "How to Choose a Media Console (TV Stand): Size, Height, and Cables",
  "description": "A media console size guide: how wide your TV stand should be, the right height for viewing, and cable management that actually works. Numbers in inches.",
  "cluster": "Frequently Asked",
  "hero": "/journal/47-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/living",
   "/ideas/how-to-choose-a-coffee-table",
   "/ideas/tv-size-for-room"
  ],
  "cta": "Shop Living",
  "primaryKeyword": "how to choose a tv stand",
  "readMinutes": 6,
  "shard": "frequently-asked"
 },
 {
  "nn": 48,
  "slug": "nightstand-height-guide",
  "title": "Nightstand Guide: Height, Width, and How to Pair Them",
  "description": "How tall a nightstand should be relative to your bed, how wide to go, and how to pair one or two. A practical bedroom sizing guide with numbers in inches.",
  "cluster": "Frequently Asked",
  "hero": "/journal/48-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/bedroom",
   "/ideas/small-bedroom-ideas",
   "/ideas/how-to-choose-a-bed-frame"
  ],
  "cta": "Shop Bedroom",
  "primaryKeyword": "nightstand height guide",
  "readMinutes": 6,
  "shard": "frequently-asked"
 },
 {
  "nn": 49,
  "slug": "how-to-choose-dining-chairs",
  "title": "How to Choose Dining Chairs: Comfort, Height, and Material",
  "description": "How to choose dining chairs that fit your table: seat height, clearance, comfort, and upholstered vs. wood. A practical guide with measurements in inches.",
  "cluster": "Frequently Asked",
  "hero": "/journal/49-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/dining",
   "/ideas/dining-table-size-guide",
   "/ideas/marble-vs-quartz-vs-wood-dining-tabletops"
  ],
  "cta": "Shop Dining",
  "primaryKeyword": "how to choose dining chairs",
  "readMinutes": 7,
  "shard": "frequently-asked"
 },
 {
  "nn": 50,
  "slug": "bar-counter-stool-height-guide",
  "title": "Bar and Counter Stool Height Guide: Counter vs. Bar, and How to Measure",
  "description": "Counter stool or bar stool? Learn the exact heights, the gap to leave under your counter, and how to measure so your stools fit the first time.",
  "cluster": "Frequently Asked",
  "hero": "/journal/50-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/dining",
   "/ideas/how-to-choose-dining-chairs",
   "/ideas/dining-table-size-guide"
  ],
  "cta": "Shop Dining",
  "primaryKeyword": "bar stool height guide",
  "readMinutes": 7,
  "shard": "frequently-asked"
 },
 {
  "nn": 51,
  "slug": "how-to-choose-a-dresser",
  "title": "How to Choose a Dresser or Chest of Drawers: Sizing, Types, and Fit",
  "description": "Dresser vs. chest, the dimensions that fit your room, drawer counts, and the construction details worth checking before you buy bedroom storage.",
  "cluster": "Frequently Asked",
  "hero": "/journal/51-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/bedroom",
   "/ideas/small-bedroom-ideas",
   "/ideas/how-to-choose-a-bed-frame"
  ],
  "cta": "Shop Bedroom",
  "primaryKeyword": "how to choose a dresser",
  "readMinutes": 7,
  "shard": "frequently-asked"
 },
 {
  "nn": 52,
  "slug": "how-to-choose-an-ottoman",
  "title": "Ottoman Guide: Storage, Cocktail, and Accent Ottomans Compared",
  "description": "Storage, cocktail, or accent ottoman? The sizing rules, heights, and trade-offs that help you pick the right ottoman for your living room — with numbers.",
  "cluster": "Frequently Asked",
  "hero": "/journal/52-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/living",
   "/ideas/how-to-choose-a-coffee-table",
   "/ideas/small-living-room-furniture-arrangement"
  ],
  "cta": "Shop Living",
  "primaryKeyword": "how to choose an ottoman",
  "readMinutes": 7,
  "shard": "frequently-asked"
 },
 {
  "nn": 53,
  "slug": "how-to-choose-a-bookcase",
  "title": "How to Choose a Bookcase or Open Shelving: Depth, Height, and Type",
  "description": "Open or closed shelving? The shelf depths, heights, and weight ratings that matter, plus how to size a bookcase to your room and what to display.",
  "cluster": "Frequently Asked",
  "hero": "/journal/53-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/bookcases",
   "/ideas/how-to-style-a-bookshelf",
   "/ideas/functional-good-looking-home-office"
  ],
  "cta": "Shop Bookcases",
  "primaryKeyword": "how to choose a bookcase",
  "readMinutes": 7,
  "shard": "frequently-asked"
 },
 {
  "nn": 54,
  "slug": "how-to-choose-a-desk",
  "title": "How to Choose a Desk for a Home Office: Size, Depth, and Type",
  "description": "Desk size guide for a home office: the surface depth and width you need, sitting vs. standing desks, and how to fit a desk and chair to your room.",
  "cluster": "Frequently Asked",
  "hero": "/journal/54-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/office",
   "/ideas/how-to-choose-an-office-chair",
   "/ideas/functional-good-looking-home-office"
  ],
  "cta": "Shop Office",
  "primaryKeyword": "how to choose a desk",
  "readMinutes": 7,
  "shard": "frequently-asked"
 },
 {
  "nn": 55,
  "slug": "headboard-guide",
  "title": "Headboard Guide: Styles, Heights, and Sizing by Bed Size",
  "description": "How wide and tall should a headboard be? A headboard guide covering width by bed size, height ranges, styles, and how it mounts to your frame.",
  "cluster": "Frequently Asked",
  "hero": "/journal/55-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/bedroom",
   "/ideas/how-to-choose-a-bed-frame",
   "/ideas/upholstered-vs-wood-vs-metal-bed-frames"
  ],
  "cta": "Shop Bedroom",
  "primaryKeyword": "headboard guide",
  "readMinutes": 7,
  "shard": "frequently-asked"
 },
 {
  "nn": 56,
  "slug": "curtain-size-guide",
  "title": "Curtain and Drapery Size Guide: Length, Width, and Hanging Height",
  "description": "A curtain size guide with the real formulas: how wide your panels should be, what length to buy, and how high to hang the rod — with tables and examples.",
  "cluster": "Frequently Asked",
  "hero": "/journal/56-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/decor",
   "/ideas/how-to-choose-curtains-for-modern-rooms"
  ],
  "cta": "Shop Decor",
  "primaryKeyword": "curtain size guide",
  "readMinutes": 7,
  "shard": "frequently-asked"
 },
 {
  "nn": 57,
  "slug": "pendant-light-height",
  "title": "Pendant Lighting Height Over a Kitchen Island (Exact Numbers)",
  "description": "How high to hang pendant lighting over a kitchen island: 30–36 inches above the surface, plus spacing rules, tall-ceiling adjustments, and a quick chart.",
  "cluster": "Frequently Asked",
  "hero": "/journal/57-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/lighting",
   "/ideas/chandelier-size-guide",
   "/ideas/layered-lighting-101"
  ],
  "cta": "Shop Lighting",
  "primaryKeyword": "pendant lighting height over kitchen island",
  "readMinutes": 6,
  "shard": "frequently-asked"
 },
 {
  "nn": 58,
  "slug": "standard-furniture-dimensions",
  "title": "Standard Furniture Dimensions: A Room-by-Room Cheat Sheet",
  "description": "A room-by-room standard furniture dimensions cheat sheet: sofa depth, table heights, desk and bed sizes, plus clearances — all in one set of quick tables.",
  "cluster": "Frequently Asked",
  "hero": "/journal/58-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/categories",
   "/ideas/sofa-dimensions-guide",
   "/ideas/dining-table-size-guide"
  ],
  "cta": "Shop by Room",
  "primaryKeyword": "standard furniture dimensions",
  "readMinutes": 8,
  "shard": "frequently-asked"
 },
 {
  "nn": 59,
  "slug": "throw-pillow-size-guide",
  "title": "Throw Pillow Sizes and Arrangement Guide",
  "description": "A throw pillow size guide with the standard sizes, how many pillows go on a sofa or bed, insert sizing for full pillows, and arrangements that actually work.",
  "cluster": "Frequently Asked",
  "hero": "/journal/59-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/throw-pillows",
   "/category/decor",
   "/ideas/how-to-mix-throw-pillows"
  ],
  "cta": "Shop Throw Pillows",
  "primaryKeyword": "throw pillow size guide",
  "readMinutes": 6,
  "shard": "frequently-asked"
 },
 {
  "nn": 60,
  "slug": "tv-size-for-room",
  "title": "What Size TV for Your Room? Viewing Distance Explained",
  "description": "Find the right TV size for your room with a simple viewing-distance formula and a diagonal-vs-distance chart — plus mounting height and stand-width guidance.",
  "cluster": "Frequently Asked",
  "hero": "/journal/60-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/living",
   "/ideas/how-to-choose-a-tv-stand"
  ],
  "cta": "Shop Media Consoles",
  "primaryKeyword": "tv size for room",
  "readMinutes": 6,
  "shard": "frequently-asked"
 },
 {
  "nn": 61,
  "slug": "bedding-sizes-guide",
  "title": "Bedding Sizes and Layering Guide",
  "description": "A bedding sizes guide with sheet, duvet, comforter, and sham measurements by mattress size, plus the order of layers for a bed that looks made every morning.",
  "cluster": "Frequently Asked",
  "hero": "/journal/61-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/bed-bath",
   "/ideas/mattress-buying-guide"
  ],
  "cta": "Shop Bed & Bath",
  "primaryKeyword": "bedding sizes guide",
  "readMinutes": 7,
  "shard": "frequently-asked"
 },
 {
  "nn": 62,
  "slug": "down-vs-foam-vs-down-alternative-sofa-cushions",
  "title": "Down vs. Foam vs. Down-Alternative Sofa Cushions: Which to Choose",
  "description": "Down, foam, or down-alternative sofa cushions? Compare comfort, support, maintenance, and longevity so your sofa feels right on day one and in year five.",
  "cluster": "Comparisons",
  "hero": "/journal/62-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/sofas",
   "/ideas/boucle-vs-linen-vs-performance-fabric",
   "/ideas/sofa-buying-mistakes"
  ],
  "cta": "Shop Sofas",
  "primaryKeyword": "sofa cushion fill guide",
  "readMinutes": 7,
  "shard": "comparisons"
 },
 {
  "nn": 63,
  "slug": "solid-wood-vs-veneer-vs-engineered-wood",
  "title": "Solid Wood vs. Veneer vs. Engineered Wood Furniture: An Honest Guide",
  "description": "Solid wood, veneer, or engineered wood furniture? Compare durability, repairability, cost, and stability so you know what you're really paying for.",
  "cluster": "Comparisons",
  "hero": "/journal/63-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/dining",
   "/ideas/how-to-mix-wood-tones",
   "/ideas/marble-vs-quartz-vs-wood-dining-tabletops"
  ],
  "cta": "Shop Dining",
  "primaryKeyword": "solid wood vs veneer",
  "readMinutes": 8,
  "shard": "comparisons"
 },
 {
  "nn": 64,
  "slug": "memory-foam-vs-hybrid-vs-innerspring-mattresses",
  "title": "Memory Foam vs. Hybrid vs. Innerspring Mattresses Compared",
  "description": "Memory foam, hybrid, or innerspring? Compare support, cooling, motion isolation, and sleep position fit so you choose the mattress type that fits how you sleep.",
  "cluster": "Comparisons",
  "hero": "/journal/64-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/mattresses",
   "/ideas/mattress-buying-guide",
   "/ideas/mattress-size-chart"
  ],
  "cta": "Shop Mattresses",
  "primaryKeyword": "mattress types compared",
  "readMinutes": 7,
  "shard": "comparisons"
 },
 {
  "nn": 65,
  "slug": "marble-vs-quartz-vs-wood-dining-tabletops",
  "title": "Marble vs. Quartz vs. Wood Dining Tabletops: Which to Choose",
  "description": "Marble, quartz, or wood dining tabletop? Compare durability, stain and scratch resistance, maintenance, and cost so you pick a surface that fits daily meals.",
  "cluster": "Comparisons",
  "hero": "/journal/65-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/dining",
   "/ideas/dining-table-size-guide",
   "/ideas/solid-wood-vs-veneer-vs-engineered-wood"
  ],
  "cta": "Shop Dining",
  "primaryKeyword": "dining table top materials",
  "readMinutes": 7,
  "shard": "comparisons"
 },
 {
  "nn": 66,
  "slug": "pendant-vs-flush-mount-vs-recessed-ceiling-lights",
  "title": "Pendant vs. Flush Mount vs. Recessed: Choosing Ceiling Lights",
  "description": "Pendant, flush mount, or recessed ceiling lights? Compare ceiling height needs, light spread, style impact, and best rooms so you light each space right.",
  "cluster": "Comparisons",
  "hero": "/journal/66-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/lighting",
   "/ideas/layered-lighting-101",
   "/ideas/pendant-light-height"
  ],
  "cta": "Shop Lighting",
  "primaryKeyword": "ceiling light types",
  "readMinutes": 7,
  "shard": "comparisons"
 },
 {
  "nn": 67,
  "slug": "sofa-bed-vs-daybed-vs-futon",
  "title": "Sofa Bed vs. Daybed vs. Futon: Guest-Sleeping Options Compared",
  "description": "Sofa bed, daybed, or futon for guests? Compare sleep comfort, everyday use, footprint, and cost so you pick the right part-time bed for your space.",
  "cluster": "Comparisons",
  "hero": "/journal/67-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/sofas",
   "/ideas/best-sectionals-for-small-spaces",
   "/ideas/how-to-furnish-a-studio-apartment"
  ],
  "cta": "Shop Sofas",
  "primaryKeyword": "sofa bed vs daybed",
  "readMinutes": 8,
  "shard": "comparisons"
 },
 {
  "nn": 68,
  "slug": "area-rug-vs-runner-vs-layered-rugs",
  "title": "Area Rug vs. Runner vs. Layered Rugs: A Placement Guide",
  "description": "Area rug, runner, or layered rugs? A placement guide to where each type belongs, by room and goal, so your rugs ground a space instead of fighting it.",
  "cluster": "Comparisons",
  "hero": "/journal/68-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/area-rugs",
   "/ideas/rug-size-guide",
   "/ideas/rug-mistakes-rooms-feel-smaller"
  ],
  "cta": "Browse Area Rugs",
  "primaryKeyword": "rug placement guide",
  "readMinutes": 8,
  "shard": "comparisons"
 },
 {
  "nn": 69,
  "slug": "upholstered-vs-wood-vs-metal-bed-frames",
  "title": "Upholstered vs. Wood vs. Metal Bed Frames: Material Comparison",
  "description": "Upholstered, wood, or metal bed frame? Compare comfort, durability, noise, maintenance, and style so you choose the frame material that fits your bedroom.",
  "cluster": "Comparisons",
  "hero": "/journal/69-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/bedroom",
   "/ideas/how-to-choose-a-bed-frame",
   "/ideas/headboard-guide"
  ],
  "cta": "Shop Bedroom",
  "primaryKeyword": "bed frame materials",
  "readMinutes": 8,
  "shard": "comparisons"
 },
 {
  "nn": 70,
  "slug": "how-to-style-a-coffee-table",
  "title": "Coffee Table Decor Ideas: The Tray-Stack-Greenery Method",
  "description": "Coffee table decor ideas that look designed, not cluttered: the tray-stack-greenery method, real height numbers, and a leave-room-for-mugs rule.",
  "cluster": "Comparisons",
  "hero": "/journal/70-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/coffee-tables",
   "/category/decor",
   "/ideas/how-to-choose-a-coffee-table"
  ],
  "cta": "Shop Decor",
  "primaryKeyword": "coffee table decor ideas",
  "readMinutes": 7,
  "shard": "comparisons",
  "publishedDate": "2026-10-07"
 },
 {
  "nn": 71,
  "slug": "how-to-style-a-bookshelf",
  "title": "How to Style a Bookshelf Like a Designer (Without the Clutter)",
  "description": "Style a bookshelf like a designer: the 60/30/10 fill rule, how to mix horizontal and vertical books, and the shelf-by-shelf placement that keeps it calm, not chaotic.",
  "cluster": "Comparisons",
  "hero": "/journal/71-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/bookcases",
   "/ideas/how-to-choose-a-bookcase"
  ],
  "cta": "Shop Bookcases",
  "primaryKeyword": "how to style a bookshelf like a designer",
  "readMinutes": 6,
  "shard": "comparisons"
 },
 {
  "nn": 72,
  "slug": "entryway-styling-console-mirror-landing-zone",
  "title": "Entryway Styling: Console, Mirror, and a Landing Zone That Works",
  "description": "Style an entryway that looks good and actually works. Console height, mirror placement, a real landing-zone checklist, and a layout for narrow halls.",
  "cluster": "Comparisons",
  "hero": "/journal/72-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/living",
   "/ideas/console-table-guide"
  ],
  "cta": "Shop Living",
  "primaryKeyword": "entryway decor ideas",
  "readMinutes": 7,
  "shard": "comparisons"
 },
 {
  "nn": 73,
  "slug": "how-to-create-a-reading-nook",
  "title": "How to Create a Reading Nook (in Any Room, Any Size)",
  "description": "Build a reading nook that you'll actually use. The chair-light-surface trio, lighting numbers that prevent eye strain, and nooks for corners and bay windows.",
  "cluster": "Comparisons",
  "hero": "/journal/73-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/living",
   "/ideas/how-to-choose-an-accent-chair"
  ],
  "cta": "Shop Living",
  "primaryKeyword": "reading nook ideas",
  "readMinutes": 7,
  "shard": "comparisons"
 },
 {
  "nn": 74,
  "slug": "functional-good-looking-home-office",
  "title": "How to Set Up a Functional, Good-Looking Home Office",
  "description": "Set up a home office that works and looks good on video. Ergonomic desk and chair numbers, lighting for calls, cable control, and a small-space layout.",
  "cluster": "Comparisons",
  "hero": "/journal/74-hero.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/office",
   "/ideas/how-to-choose-an-office-chair"
  ],
  "cta": "Shop Office",
  "primaryKeyword": "home office setup ideas",
  "readMinutes": 7,
  "shard": "comparisons"
 },
 {
  "nn": 75,
  "slug": "how-to-furnish-a-studio-apartment",
  "title": "How to Furnish a Studio Apartment: Zoning, Layout, and Smart Pieces",
  "description": "Furnish a studio that lives like separate rooms. How to zone one space, walkway and clearance numbers, and the multi-use pieces that earn their footprint.",
  "cluster": "Comparisons",
  "hero": "/journal/75-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/compact-bedroom",
   "/ideas/small-living-room-furniture-arrangement"
  ],
  "cta": "Shop Compact Furniture",
  "primaryKeyword": "studio apartment furniture ideas",
  "readMinutes": 7,
  "shard": "comparisons"
 },
 {
  "nn": 76,
  "slug": "small-bedroom-ideas",
  "title": "Small Bedroom Ideas: Layout, Storage, and Calm That Works",
  "description": "Small bedroom ideas that actually work: real clearance numbers for beds and nightstands, smart storage, and a calm palette that makes a tight room feel bigger.",
  "cluster": "Comparisons",
  "hero": "/journal/76-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/bedroom",
   "/ideas/nightstand-height-guide",
   "/ideas/how-to-choose-a-dresser"
  ],
  "cta": "Shop Bedroom",
  "primaryKeyword": "small bedroom ideas",
  "readMinutes": 6,
  "shard": "comparisons"
 },
 {
  "nn": 77,
  "slug": "dining-room-styling",
  "title": "Dining Room Styling: Centerpieces and Everyday Tablescapes",
  "description": "Dining room styling that works every day, not just for guests: simple centerpiece ratios, an everyday-to-dinner-party tablescape formula, and what to leave off.",
  "cluster": "Comparisons",
  "hero": "/journal/77-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/dining",
   "/category/decor",
   "/ideas/marble-vs-quartz-vs-wood-dining-tabletops"
  ],
  "cta": "Shop Dining",
  "primaryKeyword": "dining room styling",
  "readMinutes": 6,
  "shard": "comparisons"
 },
 {
  "nn": 78,
  "slug": "how-to-plan-and-hang-a-gallery-wall",
  "title": "How to Plan and Hang a Gallery Wall (with Real Spacing Numbers)",
  "description": "How to make a gallery wall that looks intentional: a paper-template method, real spacing numbers, the 57-inch center rule, and layouts that actually work.",
  "cluster": "Comparisons",
  "hero": "/journal/78-hero.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/decor",
   "/ideas/how-to-style-a-coffee-table"
  ],
  "cta": "Shop Decor",
  "primaryKeyword": "gallery wall layout",
  "readMinutes": 6,
  "shard": "comparisons"
 },
 {
  "nn": 79,
  "slug": "small-balcony-styling",
  "title": "Small Balcony Furniture Ideas: Make a Tiny Outdoor Room",
  "description": "Small balcony ideas that turn a few square feet into a real outdoor room: space-saving furniture, clearance numbers, weatherproof materials, and a calm layout.",
  "cluster": "Comparisons",
  "hero": "/journal/79-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/outdoor",
   "/ideas/outdoor-furniture-materials",
   "/ideas/outdoor-furniture-care-guide"
  ],
  "cta": "Shop Outdoor",
  "primaryKeyword": "small balcony ideas",
  "readMinutes": 6,
  "shard": "comparisons"
 },
 {
  "nn": 80,
  "slug": "neutral-color-palette",
  "title": "How to Build a Neutral Palette That Doesn't Feel Boring",
  "description": "How to build a neutral color palette that feels rich, not flat: warm vs. cool neutrals, the 60-30-10 split, texture and contrast tricks, and what makes beige dull.",
  "cluster": "Color, Material & Textiles",
  "hero": "/journal/80-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/decor",
   "/ideas/warm-minimalism-guide",
   "/ideas/texture-pairing-guide"
  ],
  "cta": "Explore the Collection",
  "primaryKeyword": "neutral color palette",
  "readMinutes": 6,
  "shard": "color-material-textiles"
 },
 {
  "nn": 81,
  "slug": "how-to-choose-curtains-for-modern-rooms",
  "title": "How to Choose Curtains for Modern Rooms: Fabric, Color, and Fit",
  "description": "How to choose curtains for modern rooms: which fabric for which job, color and length rules, sheer vs. blackout, and the hardware that makes them look custom.",
  "cluster": "Color, Material & Textiles",
  "hero": "/journal/81-hero.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/decor",
   "/ideas/curtain-size-guide"
  ],
  "cta": "Shop Decor",
  "primaryKeyword": "how to choose curtains",
  "readMinutes": 7,
  "shard": "color-material-textiles"
 },
 {
  "nn": 82,
  "slug": "how-to-mix-throw-pillows",
  "title": "How to Mix Throw Pillows Like a Designer (Without Overthinking It)",
  "description": "Mix throw pillows like a designer: the odd-number rule, how to combine patterns and solids, sizing, and a no-fail formula for a sofa that looks pulled together.",
  "cluster": "Color, Material & Textiles",
  "hero": "/journal/82-hero.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/throw-pillows",
   "/ideas/throw-pillow-size-guide",
   "/ideas/texture-pairing-guide",
   "/category/decor",
   "/category/living"
  ],
  "cta": "Shop Throw Pillows",
  "primaryKeyword": "how to mix throw pillows",
  "readMinutes": 8,
  "shard": "color-material-textiles"
 },
 {
  "nn": 83,
  "slug": "add-warmth-with-textiles",
  "title": "How to Make a Room Cozy with Textiles: Layering Soft Goods",
  "description": "Make any room cozier with textiles: a layering plan for rugs, throws, curtains, and cushions that adds warmth and softness without color, clutter, or renovation.",
  "cluster": "Color, Material & Textiles",
  "hero": "/journal/83-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/ideas/make-modern-home-feel-cozy",
   "/ideas/texture-pairing-guide",
   "/category/decor",
   "/category/area-rugs"
  ],
  "cta": "Shop Decor",
  "primaryKeyword": "how to make a room cozy with textiles",
  "readMinutes": 8,
  "shard": "color-material-textiles"
 },
 {
  "nn": 84,
  "slug": "how-to-mix-metals",
  "title": "How to Mix Metals in Your Home (Brass, Black, Chrome, and More)",
  "description": "Yes, you can mix metal finishes at home. Learn the dominant-metal rule, which finishes pair best, and how to combine brass, black, and chrome without it clashing.",
  "cluster": "Color, Material & Textiles",
  "hero": "/journal/84-hero.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/ideas/how-to-mix-wood-tones",
   "/ideas/texture-pairing-guide",
   "/category/lighting",
   "/category/decor"
  ],
  "cta": "Shop Lighting",
  "primaryKeyword": "how to mix metals in decor",
  "readMinutes": 7,
  "shard": "color-material-textiles"
 },
 {
  "nn": 85,
  "slug": "choosing-the-right-white",
  "title": "Choosing the Right White: Warm vs. Cool Whites Explained",
  "description": "How to choose white paint: the difference between warm and cool whites, how to read undertones, and which white to pick based on your light and your floors.",
  "cluster": "Color, Material & Textiles",
  "hero": "/journal/85-hero.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/ideas/warm-minimalism-guide",
   "/category/decor",
   "/category/living",
   "/ideas/neutral-color-palette"
  ],
  "cta": "Explore the Collection",
  "primaryKeyword": "how to choose white paint",
  "readMinutes": 7,
  "shard": "color-material-textiles"
 },
 {
  "nn": 86,
  "slug": "organic-modern-style-guide",
  "title": "Organic Modern Style: The Complete Guide to the Look",
  "description": "Organic modern style, explained: what it is, its core principles, the palette and materials, and how to get the warm, sculptural look at home without overbuying.",
  "cluster": "Trends",
  "hero": "/journal/86-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/ideas/warm-minimalism-guide",
   "/ideas/japandi-style-guide",
   "/ideas/texture-pairing-guide",
   "/category/living",
   "/category/decor"
  ],
  "cta": "Explore the Collection",
  "primaryKeyword": "organic modern style",
  "readMinutes": 9,
  "shard": "trends"
 },
 {
  "nn": 87,
  "slug": "mid-century-modern-made-warm",
  "title": "Mid-Century Modern, Made Warm: The Complete Guide",
  "description": "Mid-century modern, made warm: what MCM is, its core principles, the palette and materials, and how to soften the look so it feels cozy and current — not a showroom.",
  "cluster": "Trends",
  "hero": "/journal/87-hero.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/ideas/how-to-mix-wood-tones",
   "/ideas/warm-minimalism-guide",
   "/ideas/texture-pairing-guide",
   "/category/living",
   "/category/decor"
  ],
  "cta": "Explore the Collection",
  "primaryKeyword": "mid century modern guide",
  "readMinutes": 9,
  "shard": "trends"
 },
 {
  "nn": 88,
  "slug": "quiet-luxury-at-home",
  "title": "Quiet Luxury at Home: Understated, Not Flashy",
  "description": "Quiet luxury at home, explained: the materials, proportions, and restraint behind understated interiors — plus practical, room-by-room ways to get the look.",
  "cluster": "Trends",
  "hero": "/journal/88-hero.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/ideas/warm-minimalism-guide",
   "/ideas/neutral-color-palette",
   "/category/living",
   "/category/decor"
  ],
  "cta": "Explore the Collection",
  "primaryKeyword": "quiet luxury interior design",
  "readMinutes": 8,
  "shard": "trends"
 },
 {
  "nn": 89,
  "slug": "biophilic-design",
  "title": "Biophilic Design: Bringing Nature Indoors",
  "description": "Biophilic design, explained: how natural light, plants, materials, and views make a home calmer and healthier — plus practical, room-by-room ways to apply it.",
  "cluster": "Trends",
  "hero": "/journal/89-hero.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/ideas/texture-pairing-guide",
   "/category/decor",
   "/category/living",
   "/ideas/organic-modern-style-guide"
  ],
  "cta": "Explore the Collection",
  "primaryKeyword": "biophilic design",
  "readMinutes": 7,
  "shard": "trends"
 },
 {
  "nn": 90,
  "slug": "interior-design-trends-2026",
  "title": "2026 Interior and Furniture Trends Worth Following",
  "description": "The 2026 interior and furniture trends with real staying power — warm materials, curved forms, quiet color, and durable pieces — plus how to adopt them wisely.",
  "cluster": "Trends",
  "hero": "/journal/90-hero.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/ideas/warm-minimalism-guide",
   "/category/new-arrivals",
   "/category/living",
   "/ideas/organic-modern-style-guide"
  ],
  "cta": "Shop New Arrivals",
  "primaryKeyword": "interior design trends 2026",
  "readMinutes": 7,
  "shard": "trends"
 },
 {
  "nn": 91,
  "slug": "leather-sofa-care",
  "title": "How to Clean and Care for a Leather Sofa",
  "description": "How to clean and care for a leather sofa: routine dusting, safe spot cleaning, conditioning, and the leather types and mistakes that change everything.",
  "cluster": "Care & Logistics",
  "hero": "/journal/91-hero.webp",
  "schema": [
   "Article",
   "FAQPage",
   "HowTo (suggested, for the spot-cleaning and conditioning steps)"
  ],
  "internalLinks": [
   "/ideas/leather-vs-fabric-sofa",
   "/ideas/sofa-buying-mistakes",
   "/category/sofas"
  ],
  "cta": "Shop Sofas",
  "primaryKeyword": "leather sofa care",
  "readMinutes": 8,
  "shard": "care-logistics"
 },
 {
  "nn": 92,
  "slug": "wood-furniture-care",
  "title": "Wood Furniture Care: Cleaning, Conditioning, and Protecting",
  "description": "Wood furniture care made simple: routine cleaning, fixing water rings, conditioning, and protecting from sun and heat — by finish type, with a care schedule.",
  "cluster": "Care & Logistics",
  "hero": "/journal/92-hero.webp",
  "schema": [
   "Article",
   "FAQPage",
   "HowTo (suggested, for cleaning and water-ring removal steps)"
  ],
  "internalLinks": [
   "/ideas/how-to-mix-wood-tones",
   "/category/dining",
   "/ideas/solid-wood-vs-veneer-vs-engineered-wood"
  ],
  "cta": "Shop Dining",
  "primaryKeyword": "wood furniture care",
  "readMinutes": 8,
  "shard": "care-logistics"
 },
 {
  "nn": 93,
  "slug": "how-to-measure-for-furniture-delivery",
  "title": "How to Measure for Furniture Delivery (Doorways, Stairs, Elevators)",
  "description": "Will your sofa fit? A step-by-step guide to measuring your delivery path — doorways, hallways, stairwells, elevators, and ceiling clearance — with a checklist.",
  "cluster": "Care & Logistics",
  "hero": "/journal/93-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage",
   "HowTo (suggested, for the measuring steps)"
  ],
  "internalLinks": [
   "/ideas/sofa-dimensions-guide",
   "/ideas/how-to-buy-furniture-online-with-confidence",
   "/category/sofas"
  ],
  "cta": "Shop Sofas",
  "primaryKeyword": "how to measure for furniture delivery",
  "readMinutes": 7,
  "shard": "care-logistics"
 },
 {
  "nn": 94,
  "slug": "nursery-furniture-guide",
  "title": "Nursery Furniture Guide: Crib, Glider, Dresser, and Storage",
  "description": "A calm, practical nursery furniture guide: what to buy, clearance numbers for crib and glider, storage that lasts past the diaper years, and a safety checklist.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/94-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/bedroom",
   "/ideas/kids-room-furniture-ideas",
   "/ideas/how-to-choose-a-dresser"
  ],
  "cta": "Shop Bedroom",
  "primaryKeyword": "nursery furniture guide",
  "readMinutes": 7,
  "shard": "rooms-occasions"
 },
 {
  "nn": 95,
  "slug": "kids-room-furniture-ideas",
  "title": "Kids' Room Ideas That Grow With Them: Furniture That Lasts",
  "description": "Kids' room furniture ideas that grow with the child: pieces that adapt from toddler to teen, smart storage, layout numbers, and what's worth buying once.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/95-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/bedroom",
   "/ideas/small-bedroom-ideas",
   "/ideas/nursery-furniture-guide"
  ],
  "cta": "Shop Bedroom",
  "primaryKeyword": "kids room furniture ideas",
  "readMinutes": 7,
  "shard": "rooms-occasions"
 },
 {
  "nn": 96,
  "slug": "small-guest-room-ideas",
  "title": "The Small Guest Room: Comfortable on a Budget",
  "description": "Make a small guest room comfortable without overspending. The few pieces that matter, a dual-use layout, clearance numbers, and the hotel-style touches guests notice.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/96-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/bedroom",
   "/ideas/sofa-bed-vs-daybed-vs-futon",
   "/ideas/how-to-choose-a-dresser"
  ],
  "cta": "Shop Bedroom",
  "primaryKeyword": "small guest room ideas",
  "readMinutes": 7,
  "shard": "rooms-occasions"
 },
 {
  "nn": 97,
  "slug": "small-bathroom-storage-ideas",
  "title": "Small Bathroom Storage Ideas That Make Every Inch Work",
  "description": "Small bathroom storage ideas that work: go vertical, use the dead zones, and style it like a spa. Real dimensions for shelves, vanities, and over-toilet storage.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/97-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/bathroom"
  ],
  "cta": "Shop Bath",
  "primaryKeyword": "small bathroom storage ideas",
  "readMinutes": 7,
  "shard": "rooms-occasions"
 },
 {
  "nn": 98,
  "slug": "mudroom-drop-zone-ideas",
  "title": "The Mudroom / Drop Zone: Organizing the Entry You Actually Use",
  "description": "Build a mudroom or drop zone that actually works: the five stations every entry needs, real bench and hook heights, and a plan for homes with no mudroom at all.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/98-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/living",
   "/ideas/entryway-styling-console-mirror-landing-zone"
  ],
  "cta": "Shop Living",
  "primaryKeyword": "mudroom ideas",
  "readMinutes": 7,
  "shard": "rooms-occasions"
 },
 {
  "nn": 99,
  "slug": "breakfast-nook-ideas",
  "title": "How to Design a Breakfast Nook: Seating, Size, and Layout",
  "description": "Design a breakfast nook that seats more in less space. Banquette vs. chairs, exact seat and table dimensions, corner and bay layouts, and a small-kitchen plan.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/99-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/dining",
   "/ideas/round-vs-rectangular-dining-table"
  ],
  "cta": "Shop Dining",
  "primaryKeyword": "breakfast nook ideas",
  "readMinutes": 7,
  "shard": "rooms-occasions"
 },
 {
  "nn": 100,
  "slug": "how-to-set-a-table",
  "title": "How to Set a Table: Everyday to Dinner Party, Step by Step",
  "description": "How to set a table for any occasion: where every fork, glass, and napkin goes, exact spacing in inches, and a simple formula that scales from Tuesday to a feast.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/100-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/tabletop",
   "/category/dining",
   "/ideas/dining-room-styling"
  ],
  "cta": "Shop Tabletop & Bar",
  "primaryKeyword": "how to set a table",
  "readMinutes": 6,
  "shard": "rooms-occasions"
 },
 {
  "nn": 101,
  "slug": "hosting-for-a-crowd",
  "title": "Hosting for a Crowd: Seating, Flow, and Flexible Furniture",
  "description": "How to host a dinner party at home for more people than your table seats: extra seating that works, traffic flow, flexible furniture, and a calm, doable plan.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/101-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/dining",
   "/ideas/how-to-set-a-table",
   "/ideas/how-to-choose-an-ottoman"
  ],
  "cta": "Shop Dining",
  "primaryKeyword": "how to host a dinner party at home",
  "readMinutes": 7,
  "shard": "rooms-occasions"
 },
 {
  "nn": 102,
  "slug": "home-bar-cart-styling",
  "title": "The Home Bar Cart: How to Set Up and Style One That Works",
  "description": "Bar cart styling that's beautiful and usable: the three-zone setup, what to actually stock, the rule of three, and how to keep it from looking cluttered.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/102-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/tabletop",
   "/category/decor",
   "/ideas/dining-room-styling"
  ],
  "cta": "Shop Tabletop & Bar",
  "primaryKeyword": "bar cart styling",
  "readMinutes": 6,
  "shard": "rooms-occasions"
 },
 {
  "nn": 103,
  "slug": "outdoor-dining-setup",
  "title": "Outdoor Dining Setup: Tables, Seating, and Shade That Work",
  "description": "Outdoor dining ideas that actually work: table sizing and clearances, weatherproof seating, shade options compared, and a layout that survives real summers.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/103-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/outdoor",
   "/ideas/outdoor-furniture-materials",
   "/ideas/small-balcony-styling"
  ],
  "cta": "Shop Outdoor",
  "primaryKeyword": "outdoor dining ideas",
  "readMinutes": 7,
  "shard": "rooms-occasions"
 },
 {
  "nn": 104,
  "slug": "patio-layout-for-entertaining",
  "title": "Patio Layout for Entertaining: Zones, Flow, and Furniture",
  "description": "Patio layout ideas for entertaining: how to zone an outdoor space for dining and lounging, clearance numbers, traffic flow, and furniture that works hard.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/104-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/outdoor",
   "/ideas/outdoor-furniture-materials",
   "/ideas/outdoor-furniture-care-guide"
  ],
  "cta": "Shop Outdoor",
  "primaryKeyword": "patio layout ideas",
  "readMinutes": 7,
  "shard": "rooms-occasions"
 },
 {
  "nn": 105,
  "slug": "how-to-style-a-sideboard",
  "title": "How to Style a Sideboard or Buffet: A Simple, Layered Formula",
  "description": "How to style a sideboard or buffet so it looks intentional: the layered formula, art and lamp proportions, the rule of three, and what to leave off.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/105-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/dining",
   "/ideas/how-to-style-a-bookshelf"
  ],
  "cta": "Shop Dining",
  "primaryKeyword": "how to style a sideboard",
  "readMinutes": 7,
  "shard": "rooms-occasions"
 },
 {
  "nn": 106,
  "slug": "best-coffee-tables-for-small-living-rooms",
  "title": "The Best Coffee Tables for Small Living Rooms (2026 Guide)",
  "description": "Find the best coffee tables for small living rooms: the right size, shape, and storage features for tight spaces, plus what to look for before you buy.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/106-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage",
   "ItemList"
  ],
  "internalLinks": [
   "/category/living",
   "/ideas/how-to-choose-a-coffee-table",
   "/ideas/how-to-style-a-coffee-table"
  ],
  "cta": "Shop Living",
  "primaryKeyword": "best coffee tables for small spaces",
  "readMinutes": 6,
  "shard": "rooms-occasions"
 },
 {
  "nn": 107,
  "slug": "best-accent-chairs-for-reading",
  "title": "The Best Accent Chairs for Reading: A Buyer's Guide (2026)",
  "description": "The best accent chairs for reading balance back support, arm height, and depth. Here's what to look for and the types of reading chairs worth considering.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/107-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage",
   "ItemList"
  ],
  "internalLinks": [
   "/category/living",
   "/ideas/how-to-choose-an-accent-chair",
   "/ideas/how-to-create-a-reading-nook"
  ],
  "cta": "Shop Living",
  "primaryKeyword": "best reading chairs",
  "readMinutes": 6,
  "shard": "rooms-occasions"
 },
 {
  "nn": 108,
  "slug": "best-dining-tables-for-small-spaces",
  "title": "The Best Dining Tables for Small Spaces (2026 Buyer's Guide)",
  "description": "The best dining tables for small spaces save room without sacrificing seats. Here's what to look for, plus the table types that work in apartments and nooks.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/108-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage",
   "ItemList"
  ],
  "internalLinks": [
   "/category/dining",
   "/ideas/dining-table-size-guide",
   "/ideas/round-vs-rectangular-dining-table"
  ],
  "cta": "Shop Dining",
  "primaryKeyword": "best dining tables for small spaces",
  "readMinutes": 6,
  "shard": "rooms-occasions"
 },
 {
  "nn": 109,
  "slug": "best-bookcases-for-small-spaces",
  "title": "The Best Bookcases for Small Spaces (2026 Buyer's Guide)",
  "description": "The best bookcases for small spaces go vertical and earn their footprint. Here's what to look for, plus the shelf types that fit apartments and tight corners.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/109-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage",
   "ItemList"
  ],
  "internalLinks": [
   "/category/bookcases",
   "/ideas/how-to-choose-a-bookcase",
   "/ideas/how-to-style-a-bookshelf"
  ],
  "cta": "Shop Bookcases",
  "primaryKeyword": "best bookcases for small spaces",
  "readMinutes": 6,
  "shard": "rooms-occasions"
 },
 {
  "nn": 110,
  "slug": "best-nightstands-for-small-bedrooms",
  "title": "The Best Nightstands for Small Bedrooms (2026 Buyer's Guide)",
  "description": "The best nightstands for small bedrooms are slim, smart, and space-saving. Here's what to look for, plus the nightstand types that fit tight spaces beautifully.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/110-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage",
   "ItemList"
  ],
  "internalLinks": [
   "/category/bedroom",
   "/ideas/nightstand-height-guide",
   "/ideas/small-bedroom-ideas"
  ],
  "cta": "Shop Bedroom",
  "primaryKeyword": "best small nightstands",
  "readMinutes": 6,
  "shard": "rooms-occasions"
 },
 {
  "nn": 111,
  "slug": "best-sofas-for-families-with-kids-and-pets",
  "title": "The Best Sofas for Families with Kids and Pets (2026 Guide)",
  "description": "The best family sofa survives kids and pets: durable fabrics, sturdy frames, washable covers. Here's what to look for and the sofa types worth considering.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/111-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage",
   "ItemList"
  ],
  "internalLinks": [
   "/category/sofas",
   "/ideas/boucle-vs-linen-vs-performance-fabric",
   "/ideas/pet-friendly-furniture"
  ],
  "cta": "Shop Sofas",
  "primaryKeyword": "best family sofa",
  "readMinutes": 6,
  "shard": "rooms-occasions"
 },
 {
  "nn": 112,
  "slug": "best-storage-furniture-small-apartments",
  "title": "The Best Storage Furniture for Small Apartments: Our Picks",
  "description": "The best storage furniture for small apartments earns its footprint twice. We explain what to look for, plus seven space-saving picks that hide clutter.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/112-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage",
   "ItemList (suggested — one ListItem per product pick)"
  ],
  "internalLinks": [
   "/categories",
   "/ideas/how-to-choose-an-ottoman",
   "/ideas/how-to-furnish-a-studio-apartment"
  ],
  "cta": "Shop by Room",
  "primaryKeyword": "best storage furniture small apartment",
  "readMinutes": 7,
  "shard": "rooms-occasions"
 },
 {
  "nn": 113,
  "slug": "are-expensive-sofas-worth-it",
  "title": "Are Expensive Sofas Worth It? Price vs. Value, Explained",
  "description": "Are expensive sofas worth it? Here's what actually drives sofa cost, what you get at each quality tier, and how to decide how much to spend on a sofa.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/113-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/sofas",
   "/ideas/how-to-tell-if-a-sofa-is-well-made",
   "/ideas/sofa-buying-mistakes"
  ],
  "cta": "Shop Sofas",
  "primaryKeyword": "how much to spend on a sofa",
  "readMinutes": 6,
  "shard": "rooms-occasions"
 },
 {
  "nn": 114,
  "slug": "how-much-to-spend-on-a-mattress",
  "title": "How Much Should You Spend on a Mattress? A Value Guide",
  "description": "How much should you spend on a mattress? Here's what drives the price, what you get at each quality tier, and how to decide — without chasing the biggest number.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/114-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/mattresses",
   "/ideas/mattress-materials-and-certifications",
   "/ideas/memory-foam-vs-hybrid-vs-innerspring-mattresses"
  ],
  "cta": "Shop Mattresses",
  "primaryKeyword": "how much to spend on a mattress",
  "readMinutes": 6,
  "shard": "rooms-occasions"
 },
 {
  "nn": 115,
  "slug": "how-much-to-spend-on-a-dining-table",
  "title": "How Much to Spend on a Dining Table: A Value Guide",
  "description": "How much should you spend on a dining table? Here's what drives the price, what you get at each quality tier, and how to decide where your money is best placed.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/115-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/dining",
   "/ideas/marble-vs-quartz-vs-wood-dining-tabletops",
   "/ideas/solid-wood-vs-veneer-vs-engineered-wood"
  ],
  "cta": "Shop Dining",
  "primaryKeyword": "dining table budget guide",
  "readMinutes": 6,
  "shard": "rooms-occasions"
 },
 {
  "nn": 116,
  "slug": "where-to-splurge-and-where-to-save-on-furniture",
  "title": "Where to Splurge and Where to Save on Furniture",
  "description": "Where should you splurge and where should you save on furniture? A simple framework plus category-by-category guidance to spend your budget where it matters most.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/116-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/categories",
   "/ideas/are-expensive-sofas-worth-it",
   "/ideas/how-to-mix-high-and-low"
  ],
  "cta": "Shop by Room",
  "primaryKeyword": "where to splurge on furniture",
  "readMinutes": 6,
  "shard": "rooms-occasions"
 },
 {
  "nn": 117,
  "slug": "best-lighting-for-a-living-room",
  "title": "Living Room Lighting Ideas: How to Layer Light, Plus Our Picks",
  "description": "The best living room lighting layers three kinds of light. We explain what to look for, plus seven fixture picks that make a room feel warm and finished.",
  "cluster": "Rooms & Occasions",
  "hero": "/journal/117-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage",
   "ItemList (suggested — one ListItem per product pick)"
  ],
  "internalLinks": [
   "/category/lighting",
   "/ideas/layered-lighting-101",
   "/ideas/pendant-vs-flush-mount-vs-recessed-ceiling-lights"
  ],
  "cta": "Shop Lighting",
  "primaryKeyword": "best living room lighting",
  "readMinutes": 6,
  "shard": "rooms-occasions"
 },
 {
  "nn": 118,
  "slug": "how-to-tell-if-a-sofa-is-well-made",
  "title": "How to Tell If a Sofa Is Well Made: A Buyer's Checklist",
  "description": "Learn how to tell if a sofa is well made: frame, joinery, suspension, foam, and stitching checks you can do in a showroom or on a product page before you buy.",
  "cluster": "Materials & Quality",
  "hero": "/journal/118-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/sofas",
   "/ideas/sofa-frame-construction-explained",
   "/ideas/foam-density-and-cushion-quality"
  ],
  "cta": "Shop Sofas",
  "primaryKeyword": "how to tell sofa quality",
  "readMinutes": 7,
  "shard": "materials-quality"
 },
 {
  "nn": 119,
  "slug": "sofa-frame-construction-explained",
  "title": "Sofa Frame Construction, Explained: Materials, Joints, Springs",
  "description": "Sofa frame construction explained: kiln-dried hardwood vs. plywood vs. particleboard, joint types, corner blocks, and suspension — what to look for and why.",
  "cluster": "Materials & Quality",
  "hero": "/journal/119-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/sofas",
   "/ideas/how-to-tell-if-a-sofa-is-well-made",
   "/ideas/down-vs-foam-vs-down-alternative-sofa-cushions"
  ],
  "cta": "Shop Sofas",
  "primaryKeyword": "sofa frame construction",
  "readMinutes": 7,
  "shard": "materials-quality"
 },
 {
  "nn": 120,
  "slug": "martindale-rub-count-explained",
  "title": "Martindale Rub Count: Fabric Durability Explained for Sofas",
  "description": "What is a Martindale rub count, and how many rubs do you need? Compare durability thresholds, double rubs, and pilling so you pick fabric that lasts.",
  "cluster": "Materials & Quality",
  "hero": "/journal/120-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/sofas",
   "/ideas/boucle-vs-linen-vs-performance-fabric",
   "/ideas/what-is-performance-fabric"
  ],
  "cta": "Shop Sofas",
  "primaryKeyword": "martindale rub count",
  "readMinutes": 7,
  "shard": "materials-quality"
 },
 {
  "nn": 121,
  "slug": "foam-density-and-cushion-quality",
  "title": "Foam Density and Cushion Quality, Explained (lb/ft³ Guide)",
  "description": "Foam density explained in lb/ft³: what the number means, density vs. firmness vs. ILD, and the ranges to look for so cushions hold their shape for years.",
  "cluster": "Materials & Quality",
  "hero": "/journal/121-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/sofas",
   "/ideas/down-vs-foam-vs-down-alternative-sofa-cushions",
   "/ideas/how-to-tell-if-a-sofa-is-well-made"
  ],
  "cta": "Shop Sofas",
  "primaryKeyword": "foam density guide",
  "readMinutes": 7,
  "shard": "materials-quality"
 },
 {
  "nn": 122,
  "slug": "wood-joinery-types-explained",
  "title": "Wood Joinery Types, Explained: Dovetail, Mortise-and-Tenon & More",
  "description": "Wood joinery types explained: dovetail, mortise-and-tenon, dowel, biscuit, and pocket-screw joints — how strong each is and how to spot quality furniture.",
  "cluster": "Materials & Quality",
  "hero": "/journal/122-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/dining",
   "/ideas/solid-wood-vs-veneer-vs-engineered-wood",
   "/ideas/drawer-construction-and-hardware-quality"
  ],
  "cta": "Shop Dining",
  "primaryKeyword": "wood joinery types",
  "readMinutes": 6,
  "shard": "materials-quality"
 },
 {
  "nn": 123,
  "slug": "solid-wood-types-compared",
  "title": "Solid Wood Types Compared: Oak, Walnut, Ash, Mango & Acacia",
  "description": "Compare solid wood types for furniture — oak, walnut, ash, mango, and acacia — by hardness, grain, color, and cost so you choose the right species for the job.",
  "cluster": "Materials & Quality",
  "hero": "/journal/123-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/dining",
   "/ideas/how-to-mix-wood-tones",
   "/ideas/solid-wood-vs-veneer-vs-engineered-wood"
  ],
  "cta": "Shop Dining",
  "primaryKeyword": "types of wood for furniture",
  "readMinutes": 8,
  "shard": "materials-quality"
 },
 {
  "nn": 124,
  "slug": "what-makes-a-rug-high-quality",
  "title": "What Makes a Rug High Quality? Hand vs. Machine, Knot Count",
  "description": "Learn what makes a rug high quality: hand-knotted vs. machine-made, knot count, fiber, weave, and pile, so you can judge value and longevity before you buy.",
  "cluster": "Materials & Quality",
  "hero": "/journal/124-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/area-rugs",
   "/ideas/wool-vs-jute-vs-synthetic-rugs",
   "/ideas/area-rug-vs-runner-vs-layered-rugs"
  ],
  "cta": "Browse Area Rugs",
  "primaryKeyword": "rug quality guide",
  "readMinutes": 6,
  "shard": "materials-quality"
 },
 {
  "nn": 125,
  "slug": "leather-grades-explained",
  "title": "Leather Grades Explained: Full-Grain, Top-Grain, Bonded",
  "description": "Full-grain, top-grain, genuine, bonded: leather grades explained simply, so you can tell real quality from marketing and choose the right sofa leather.",
  "cluster": "Materials & Quality",
  "hero": "/journal/125-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/sofas",
   "/ideas/leather-vs-fabric-sofa",
   "/ideas/leather-sofa-care"
  ],
  "cta": "Shop Sofas",
  "primaryKeyword": "leather grades explained",
  "readMinutes": 7,
  "shard": "materials-quality"
 },
 {
  "nn": 126,
  "slug": "sustainable-furniture-certifications",
  "title": "Sustainable Furniture: What the Certifications Actually Mean",
  "description": "A clear guide to sustainable furniture certifications: FSC, GREENGUARD, OEKO-TEX, GOTS, and more, what each one verifies and how to read them honestly.",
  "cluster": "Materials & Quality",
  "hero": "/journal/126-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/sustainability",
   "/ideas/what-is-fsc-certified-wood",
   "/ideas/mattress-materials-and-certifications"
  ],
  "cta": "Explore the Collection",
  "primaryKeyword": "sustainable furniture certifications",
  "readMinutes": 6,
  "shard": "materials-quality"
 },
 {
  "nn": 127,
  "slug": "what-is-fsc-certified-wood",
  "title": "What Is FSC-Certified Wood? A Plain-English Guide",
  "description": "What is FSC-certified wood? A clear guide to the Forest Stewardship Council label, what it verifies, the FSC logo types, and how to spot it on furniture.",
  "cluster": "Materials & Quality",
  "hero": "/journal/127-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/sustainability",
   "/category/dining",
   "/ideas/sustainable-furniture-certifications"
  ],
  "cta": "Shop Dining",
  "primaryKeyword": "fsc certified wood",
  "readMinutes": 6,
  "shard": "materials-quality"
 },
 {
  "nn": 128,
  "slug": "how-long-should-furniture-last",
  "title": "How Long Should Furniture Last? Lifespan by Category",
  "description": "How long should furniture last? A category-by-category lifespan guide for sofas, mattresses, dining tables, and more, plus what shortens or extends it.",
  "cluster": "Materials & Quality",
  "hero": "/journal/128-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/categories",
   "/ideas/how-to-tell-if-a-sofa-is-well-made",
   "/ideas/where-to-splurge-and-where-to-save-on-furniture"
  ],
  "cta": "Shop by Room",
  "primaryKeyword": "furniture lifespan",
  "readMinutes": 6,
  "shard": "materials-quality"
 },
 {
  "nn": 129,
  "slug": "drawer-construction-and-hardware-quality",
  "title": "Drawer Construction and Hardware Quality, Explained",
  "description": "How to judge drawer construction and hardware quality: joinery, drawer boxes, glides, and slides, so you can spot a well-built dresser before you buy.",
  "cluster": "Materials & Quality",
  "hero": "/journal/129-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/bedroom",
   "/ideas/how-to-choose-a-dresser",
   "/ideas/wood-joinery-types-explained"
  ],
  "cta": "Shop Bedroom",
  "primaryKeyword": "drawer construction quality",
  "readMinutes": 6,
  "shard": "materials-quality"
 },
 {
  "nn": 130,
  "slug": "mattress-materials-and-certifications",
  "title": "Mattress Materials and Certifications (CertiPUR-US Guide)",
  "description": "A clear guide to mattress materials, foam, latex, innerspring, hybrid, and the certifications like CertiPUR-US and OEKO-TEX that tell you what's inside.",
  "cluster": "Materials & Quality",
  "hero": "/journal/130-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/mattresses",
   "/ideas/memory-foam-vs-hybrid-vs-innerspring-mattresses",
   "/ideas/how-much-to-spend-on-a-mattress"
  ],
  "cta": "Shop Mattresses",
  "primaryKeyword": "mattress materials guide",
  "readMinutes": 7,
  "shard": "materials-quality"
 },
 {
  "nn": 131,
  "slug": "how-to-move-furniture",
  "title": "Moving Furniture: A Stress-Free Guide (Packing, Protecting, and Lifting)",
  "description": "Move furniture without dents, scratches, or a sore back. A room-by-room guide to disassembly, wrapping, lifting, and protecting big pieces on moving day.",
  "cluster": "Materials & Quality",
  "hero": "/journal/131-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/sofas",
   "/ideas/how-to-measure-for-furniture-delivery"
  ],
  "cta": "Shop Sofas",
  "primaryKeyword": "how to move furniture",
  "readMinutes": 7,
  "shard": "materials-quality"
 },
 {
  "nn": 132,
  "slug": "downsizing-furniture-tips",
  "title": "Downsizing: What Furniture to Keep, Sell, or Replace",
  "description": "Moving to a smaller home? A clear-eyed guide to deciding which furniture to keep, sell, or replace — with a scale-down checklist and room-by-room priorities.",
  "cluster": "Materials & Quality",
  "hero": "/journal/132-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/categories",
   "/ideas/how-to-furnish-a-studio-apartment",
   "/ideas/how-to-donate-or-sell-old-furniture-responsibly"
  ],
  "cta": "Shop by Room",
  "primaryKeyword": "downsizing furniture tips",
  "readMinutes": 6,
  "shard": "materials-quality"
 },
 {
  "nn": 133,
  "slug": "furniture-for-new-parents",
  "title": "Furnishing a Home With a New Baby: What You Actually Need",
  "description": "Furnishing a home for a new baby? A calm, practical guide to what you truly need, what can wait, and how to choose pieces that grow with your family.",
  "cluster": "Materials & Quality",
  "hero": "/journal/133-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/bedroom",
   "/ideas/nursery-furniture-guide",
   "/ideas/childproofing-furniture"
  ],
  "cta": "Shop by Room",
  "primaryKeyword": "furniture for new parents",
  "readMinutes": 6,
  "shard": "materials-quality"
 },
 {
  "nn": 134,
  "slug": "pet-friendly-furniture",
  "title": "Pet-Friendly Furniture and Fabrics: What Holds Up to Cats and Dogs",
  "description": "Live with cats or dogs? A practical guide to pet-friendly furniture and fabrics — the best upholstery for fur, claws, and accidents, plus colors and care.",
  "cluster": "Materials & Quality",
  "hero": "/journal/134-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/sofas",
   "/ideas/boucle-vs-linen-vs-performance-fabric",
   "/ideas/what-is-performance-fabric"
  ],
  "cta": "Shop Sofas",
  "primaryKeyword": "pet friendly furniture",
  "readMinutes": 7,
  "shard": "materials-quality"
 },
 {
  "nn": 135,
  "slug": "childproofing-furniture",
  "title": "Childproofing Furniture: Anchoring, Safer Edges, and Tip-Over Prevention",
  "description": "Childproofing furniture starts with anchoring. A practical guide to anti-tip prevention, safer edges, and safer choices — following manufacturer and CPSC guidance.",
  "cluster": "Materials & Quality",
  "hero": "/journal/135-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/bedroom",
   "/ideas/furniture-for-new-parents",
   "/ideas/drawer-construction-and-hardware-quality"
  ],
  "cta": "Shop Bedroom",
  "primaryKeyword": "childproofing furniture",
  "readMinutes": 7,
  "shard": "materials-quality"
 },
 {
  "nn": 136,
  "slug": "accessible-furniture",
  "title": "Furniture for Aging in Place and Accessibility: A Practical Guide",
  "description": "Choosing furniture for aging in place? A practical guide to seat heights, stable supportive pieces, and accessible layouts that make a home easier to live in.",
  "cluster": "Materials & Quality",
  "hero": "/journal/136-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/categories",
   "/ideas/how-to-choose-an-accent-chair",
   "/ideas/how-long-should-furniture-last"
  ],
  "cta": "Shop by Room",
  "primaryKeyword": "accessible furniture",
  "readMinutes": 7,
  "shard": "materials-quality"
 },
 {
  "nn": 137,
  "slug": "roommate-apartment-furniture",
  "title": "Furnishing a Shared Apartment With Roommates: Who Buys What",
  "description": "Moving in with roommates? A fair, practical guide to furnishing a shared apartment — who buys what, splitting costs, shared vs. personal pieces, and move-out plans.",
  "cluster": "Materials & Quality",
  "hero": "/journal/137-hero-v2.webp",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/categories",
   "/ideas/first-apartment-furniture-checklist",
   "/ideas/how-to-mix-high-and-low"
  ],
  "cta": "Shop by Room",
  "primaryKeyword": "roommate apartment furniture",
  "readMinutes": 7,
  "shard": "materials-quality"
 },
 {
  "nn": 138,
  "slug": "furnishing-your-first-home-after-renting",
  "title": "Furnishing Your First Home After Renting: A Stage-by-Stage Guide",
  "description": "Furnishing your first home after renting? A stage-by-stage plan for spending wisely, scaling up from apartment sizes, and avoiding rookie mistakes.",
  "cluster": "Materials & Quality",
  "hero": "/journal/138-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/categories",
   "/ideas/first-apartment-furniture-checklist",
   "/category/living"
  ],
  "cta": "Shop by Room",
  "primaryKeyword": "first home furniture guide",
  "readMinutes": 7,
  "shard": "materials-quality"
 },
 {
  "nn": 139,
  "slug": "how-to-donate-or-sell-old-furniture-responsibly",
  "title": "How to Get Rid of Old Furniture Responsibly: Donate, Sell, or Recycle",
  "description": "How to get rid of old furniture without the landfill: where to donate, how to sell it fast, what to recycle, and how to choose the right path for each piece.",
  "cluster": "Materials & Quality",
  "hero": "/journal/139-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/categories",
   "/ideas/best-time-to-buy-furniture",
   "/category/living"
  ],
  "cta": "Shop by Room",
  "primaryKeyword": "how to get rid of old furniture",
  "readMinutes": 6,
  "shard": "materials-quality"
 },
 {
  "nn": 140,
  "slug": "how-to-mix-high-and-low",
  "title": "How to Mix High and Low: The Designer Look on a Budget",
  "description": "How to mix high and low for a designer look on a budget: where to splurge, where to save, and the styling rules that make a cheap room read as expensive.",
  "cluster": "Materials & Quality",
  "hero": "/journal/140-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/decor",
   "/ideas/neutral-color-palette",
   "/category/living"
  ],
  "cta": "Explore the Collection",
  "primaryKeyword": "high low decorating",
  "readMinutes": 6,
  "shard": "materials-quality"
 },
 {
  "nn": 141,
  "slug": "how-to-shop-secondhand-and-vintage-furniture",
  "title": "How to Shop Secondhand and Vintage Furniture: A Buyer's Guide",
  "description": "Buying vintage furniture tips that help: where to look, how to inspect for quality and damage, what's worth restoring, and how to tell a real find from junk.",
  "cluster": "Materials & Quality",
  "hero": "/journal/141-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/decor",
   "/ideas/how-to-mix-high-and-low",
   "/ideas/solid-wood-vs-veneer-vs-engineered-wood"
  ],
  "cta": "Explore the Collection",
  "primaryKeyword": "buying vintage furniture tips",
  "readMinutes": 6,
  "shard": "materials-quality"
 },
 {
  "nn": 142,
  "slug": "decorating-when-you-and-your-partner-disagree-on-style",
  "title": "Decorating When You and Your Partner Disagree on Style",
  "description": "Decorating with a partner who has a different style? A calm, practical guide to finding common ground and building a home that feels like both of you.",
  "cluster": "Materials & Quality",
  "hero": "/journal/142-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/design-services",
   "/ideas/neutral-color-palette",
   "/ideas/organic-modern-style-guide"
  ],
  "cta": "Get a Free Design Plan",
  "primaryKeyword": "decorating with a partner",
  "readMinutes": 7,
  "shard": "materials-quality"
 },
 {
  "nn": 143,
  "slug": "the-seasonal-refresh",
  "title": "The Seasonal Refresh: Updating Your Home Between Seasons",
  "description": "A seasonal home refresh without the overhaul: a simple swap system for textiles, light, and scent that shifts a room with the weather in one afternoon.",
  "cluster": "Materials & Quality",
  "hero": "/journal/143-hero-v2.webp",
  "schema": [
   "Article",
   "FAQPage"
  ],
  "internalLinks": [
   "/category/decor",
   "/ideas/add-warmth-with-textiles",
   "/ideas/throw-pillow-size-guide"
  ],
  "cta": "Shop Decor",
  "primaryKeyword": "seasonal home refresh",
  "readMinutes": 7,
  "shard": "materials-quality"
 },
 {
  "nn": 144,
  "slug": "end-table-height-guide",
  "title": "End Table Height Guide: Sizing Beside a Sofa",
  "description": "How tall an end table should be next to a sofa or chair, how big to go, and how far to place it. A practical side table sizing guide with numbers in inches.",
  "cluster": "Sizing Guides",
  "hero": "/journal/144-hero.jpg",
  "heroAlt": "24\" White and Gold Faux Marble and Metal Oval End Table",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/end-tables",
   "/category/living",
   "/ideas/how-to-choose-a-coffee-table",
   "/ideas/small-living-room-furniture-arrangement",
   "/ideas/table-lamp-size-guide"
  ],
  "cta": "Shop End & Side Tables",
  "primaryKeyword": "end table height",
  "publishedDate": "2026-09-13",
  "readMinutes": 5,
  "shard": "sizing-guides"
 },
 {
  "nn": 145,
  "slug": "table-lamp-size-guide",
  "title": "Table Lamp Size Guide: How Tall & How Wide",
  "description": "How tall a table lamp should be for a nightstand, end table, or console, how wide the shade should be, and how to keep light at eye level. Numbers in inches.",
  "cluster": "Sizing Guides",
  "hero": "/journal/145-hero.jpg",
  "heroAlt": "24\" Silver Bedside Table Lamp With White Drum Shade",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/table-lamps",
   "/ideas/layered-lighting-101",
   "/ideas/nightstand-height-guide",
   "/ideas/lampshade-size-guide"
  ],
  "cta": "Shop Table Lamps",
  "primaryKeyword": "table lamp size guide",
  "publishedDate": "2026-09-13",
  "readMinutes": 4,
  "shard": "sizing-guides"
 },
 {
  "nn": 146,
  "slug": "mirror-size-guide",
  "title": "Mirror Size Guide: How Big & How High to Hang",
  "description": "What size mirror to hang over a dresser, console, sofa, or bathroom vanity, how high to hang it, and when a full-length mirror makes sense. Numbers in inches.",
  "cluster": "Sizing Guides",
  "hero": "/journal/146-hero.jpg",
  "heroAlt": "35\" Black Wood Square Mounted Framed Dresser Mirror",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/mirrors",
   "/ideas/entryway-styling-console-mirror-landing-zone",
   "/ideas/how-to-choose-a-dresser",
   "/ideas/small-bedroom-ideas"
  ],
  "cta": "Shop Mirrors",
  "primaryKeyword": "mirror size guide",
  "publishedDate": "2026-09-13",
  "readMinutes": 4,
  "shard": "sizing-guides"
 },
 {
  "nn": 147,
  "slug": "wall-art-size-guide",
  "title": "Wall Art Size Guide: Over a Sofa, Bed & More",
  "description": "How big wall art should be over a sofa, bed, or console, how high to hang it, and when to use one large piece or a set. A simple sizing guide in inches.",
  "cluster": "Sizing Guides",
  "hero": "/journal/147-hero.jpg",
  "heroAlt": "Restful Landscape I White Framed Wall Art",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/wall-decor",
   "/ideas/how-to-plan-and-hang-a-gallery-wall",
   "/ideas/living-room-feels-unfinished",
   "/ideas/headboard-guide"
  ],
  "cta": "Shop Wall Art & Decor",
  "primaryKeyword": "wall art size guide",
  "publishedDate": "2026-09-13",
  "readMinutes": 4,
  "shard": "sizing-guides"
 },
 {
  "nn": 148,
  "slug": "lampshade-size-guide",
  "title": "Lampshade Size Guide: Measure, Fit & Style",
  "description": "How to measure a lampshade, what size shade fits your lamp base, how fitters like spider, UNO, and clip-on work, and which shade shape to choose.",
  "cluster": "Sizing Guides",
  "hero": "/journal/148-hero.jpg",
  "heroAlt": "Light Brown Burlap Plain Drum Lamp Shade",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/lampshades",
   "/ideas/table-lamp-size-guide",
   "/ideas/floor-lamp-buying-guide",
   "/ideas/lighting-mistakes"
  ],
  "cta": "Shop Lampshades",
  "primaryKeyword": "lampshade size guide",
  "publishedDate": "2026-09-13",
  "readMinutes": 4,
  "shard": "sizing-guides"
 },
 {
  "nn": 149,
  "slug": "outdoor-rug-size-guide",
  "title": "Outdoor Rug Size Guide: Patio & Deck Sizing",
  "description": "What size outdoor rug fits your patio seating or dining set, how far it should extend, and how to place, secure and care for it. Numbers in feet and inches.",
  "cluster": "Sizing Guides",
  "hero": "/journal/104-hero-v2.webp",
  "heroAlt": "Covered patio with an outdoor sofa, woven armchairs and a flat-woven rug under the coffee table",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/outdoor-rugs",
   "/ideas/patio-layout-for-entertaining",
   "/ideas/small-balcony-styling",
   "/ideas/rug-size-guide"
  ],
  "cta": "Shop Outdoor Rugs",
  "primaryKeyword": "outdoor rug size guide",
  "publishedDate": "2026-09-19",
  "readMinutes": 5,
  "shard": "sizing-guides"
 },
 {
  "nn": 150,
  "slug": "wall-sconce-height-guide",
  "title": "Wall Sconce Height & Placement Guide",
  "description": "How high to hang wall sconces in a living room, hallway, bathroom, bedroom and stairway, how far apart to space them, and how to size them.",
  "cluster": "Sizing Guides",
  "hero": "/journal/31-hero.webp",
  "heroAlt": "Warmly lit living room with a sofa, armchair, arc floor lamp and woven rug",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/wall-lighting",
   "/ideas/layered-lighting-101",
   "/ideas/lighting-mistakes",
   "/ideas/mirror-size-guide"
  ],
  "cta": "Shop Wall Lighting",
  "primaryKeyword": "sconce placement",
  "publishedDate": "2026-09-19",
  "readMinutes": 4,
  "shard": "sizing-guides"
 },
 {
  "nn": 151,
  "slug": "throw-blanket-size-guide",
  "title": "Throw Blanket Size Guide: Sofa, Bed & Chair",
  "description": "Standard throw blanket sizes, which size suits a sofa, bed or armchair, how to drape one so it looks intentional, and which fabrics to choose.",
  "cluster": "Sizing Guides",
  "hero": "/journal/83-hero-v2.webp",
  "heroAlt": "Terrace sofa and armchair layered with linen throws and cushions",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/throws-blankets",
   "/ideas/add-warmth-with-textiles",
   "/ideas/how-to-mix-throw-pillows",
   "/ideas/texture-pairing-guide"
  ],
  "cta": "Shop Throws & Blankets",
  "primaryKeyword": "throw blanket size",
  "publishedDate": "2026-09-19",
  "readMinutes": 4,
  "shard": "sizing-guides"
 },
 {
  "nn": 152,
  "slug": "doormat-size-guide",
  "title": "Standard Doormat Size: What Size Mat for Your Door",
  "description": "How big a doormat should be for a single, double or side door, how deep it needs to be, and whether coir or rubber suits your entry. Sizes in inches.",
  "cluster": "Sizing Guides",
  "hero": "/journal/98-hero-v2.webp",
  "heroAlt": "Entryway with wall hooks, woven baskets and a flat woven mat by the door",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/doormats",
   "/ideas/entryway-styling-console-mirror-landing-zone",
   "/ideas/mudroom-drop-zone-ideas",
   "/ideas/outdoor-rug-size-guide"
  ],
  "cta": "Shop Doormats",
  "primaryKeyword": "standard doormat size",
  "publishedDate": "2026-09-19",
  "readMinutes": 4,
  "shard": "sizing-guides"
 },
 {
  "nn": 153,
  "slug": "vase-size-guide",
  "title": "Vase Size Guide: Height, Shape & Placement",
  "description": "How tall a vase should be for your flowers, which shape suits which stems, and how big to go on a dining table, console, mantel or floor. Sizes in inches.",
  "cluster": "Sizing Guides",
  "hero": "/journal/105-hero-v2.webp",
  "heroAlt": "Walnut sideboard styled with ceramic vases, a table lamp and framed art",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/vases",
   "/ideas/how-to-style-a-sideboard",
   "/ideas/how-to-style-a-coffee-table",
   "/ideas/dining-room-styling"
  ],
  "cta": "Shop Vases",
  "primaryKeyword": "vase size guide",
  "publishedDate": "2026-09-19",
  "readMinutes": 4,
  "shard": "sizing-guides"
 },
 {
  "nn": 154,
  "slug": "christmas-tree-size-guide",
  "title": "What Size Christmas Tree Do I Need? Height, Width, Lights & Ornaments",
  "description": "How tall a Christmas tree your ceiling takes, how much floor it needs, and how many lights and ornaments to plan for, with a chart by ceiling height.",
  "cluster": "Sizing Guides",
  "hero": "/journal/154-hero.webp",
  "heroAlt": "8-foot slender flocked pine Christmas tree, 96 inches tall and 50 inches wide",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/christmas-trees",
   "/category/ornaments",
   "/ideas/small-living-room-furniture-arrangement",
   "/ideas/doormat-size-guide"
  ],
  "cta": "Shop Christmas Trees",
  "primaryKeyword": "what size christmas tree do i need",
  "publishedDate": "2026-10-02",
  "readMinutes": 5,
  "shard": "sizing-guides"
 },
 {
  "nn": 155,
  "slug": "are-washable-rugs-worth-it",
  "title": "Are Washable Rugs Worth It? What They're Good At, Sizes, and How to Wash Them",
  "description": "What makes a rug washable, where washable rugs shine and fall short, which sizes fit a home washer, and how to wash one without damaging it.",
  "cluster": "Frequently Asked",
  "hero": "/journal/155-hero.webp",
  "heroAlt": "Blue washable indoor-outdoor area rug on a wooden deck with wicker patio seating",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/outdoor-rugs",
   "/tools/rug-size-calculator",
   "/ideas/rug-size-guide",
   "/ideas/wool-vs-jute-vs-synthetic-rugs",
   "/ideas/rug-care-101"
  ],
  "cta": "Shop Washable Rugs",
  "primaryKeyword": "are washable rugs worth it",
  "publishedDate": "2026-10-03",
  "readMinutes": 5,
  "shard": "frequently-asked"
 },
 {
  "nn": 156,
  "slug": "how-to-decorate-with-sculptures",
  "title": "How to Decorate with Sculptures: Size, Placement, and Grouping",
  "description": "How big a sculpture should be for a console, coffee table or shelf, how to group decorative objects, and where they look best.",
  "cluster": "Style & Authority",
  "hero": "/journal/156-hero.webp",
  "heroAlt": "Gunmetal gray abstract metal sculptures on a wood sideboard beside a potted plant",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/sculptures",
   "/ideas/how-to-style-a-bookshelf",
   "/ideas/how-to-style-a-sideboard",
   "/ideas/how-to-style-a-coffee-table",
   "/ideas/how-to-mix-metals"
  ],
  "cta": "Shop Sculptures",
  "primaryKeyword": "how to decorate with sculptures",
  "publishedDate": "2026-10-03",
  "readMinutes": 4,
  "shard": "style-authority"
 },
 {
  "nn": 157,
  "slug": "wall-clock-size-guide",
  "title": "What Size Wall Clock? Size and Hanging Height by Room",
  "description": "How big a wall clock should be over a sofa, console, mantel or open wall, how high to hang it, and how to choose one you can actually read.",
  "cluster": "Sizing Guides",
  "hero": "/journal/157-hero.webp",
  "heroAlt": "Close-up of a 42-inch black iron and natural wood round wall clock with Roman numeral frame",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/wall-clocks",
   "/ideas/wall-art-size-guide",
   "/ideas/mirror-size-guide",
   "/ideas/how-to-plan-and-hang-a-gallery-wall",
   "/tools/wall-art-size-calculator"
  ],
  "cta": "Shop Wall Clocks",
  "primaryKeyword": "what size wall clock",
  "publishedDate": "2026-10-03",
  "readMinutes": 4,
  "shard": "sizing-guides"
 },
 {
  "nn": 158,
  "slug": "bathroom-vanity-size-guide",
  "title": "What Size Bathroom Vanity? Width, Height, Depth and Clearances",
  "description": "Standard bathroom vanity widths, heights and depths, how much space to leave around a vanity and a toilet, and single vs double sinks.",
  "cluster": "Sizing Guides",
  "hero": "/journal/158-hero.webp",
  "heroAlt": "30-inch green fluted floating bathroom vanity with a white vessel sink under a round backlit mirror",
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/bathroom-vanities",
   "/ideas/mirror-size-guide",
   "/ideas/wall-sconce-height-guide",
   "/ideas/small-bathroom-storage-ideas"
  ],
  "cta": "Shop Bathroom Vanities",
  "primaryKeyword": "what size bathroom vanity",
  "publishedDate": "2026-10-05",
  "readMinutes": 5,
  "shard": "sizing-guides"
 },
 {
  "nn": 159,
  "slug": "picture-frame-sizes",
  "title": "Standard Picture Frame Sizes: A Complete Guide (in Inches)",
  "description": "The standard picture frame sizes from 4x6 to 24x36, how to measure a frame, when to add a mat, and which size fits which print or photo.",
  "cluster": "Sizing Guides",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/picture-frames",
   "/ideas/how-to-plan-and-hang-a-gallery-wall",
   "/ideas/wall-art-size-guide"
  ],
  "cta": "Shop Picture Frames",
  "primaryKeyword": "picture frame sizes",
  "publishedDate": "2026-10-07",
  "readMinutes": 5,
  "shard": "sizing-guides"
 },
 {
  "nn": 160,
  "slug": "duvet-vs-comforter",
  "title": "Duvet vs Comforter: What's the Difference and Which Should You Buy?",
  "description": "The real difference between a duvet and a comforter, what a duvet cover is for, which is warmer and easier to wash, and which one suits how you actually sleep.",
  "cluster": "Comparisons",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/comforters-duvets",
   "/category/throws-blankets",
   "/ideas/throw-blanket-size-guide"
  ],
  "cta": "Shop Comforters & Duvets",
  "primaryKeyword": "duvet vs comforter",
  "publishedDate": "2026-10-07",
  "readMinutes": 5,
  "shard": "comparisons"
 },
 {
  "nn": 161,
  "slug": "peel-and-stick-backsplash-guide",
  "title": "Peel and Stick Backsplash: Are They Any Good and How to Install Them Right",
  "description": "Are peel and stick backsplash tiles worth it, how long they last, whether they can go over existing tile, and the installation steps that make them look like the real thing.",
  "cluster": "Rooms & Occasions",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/peel-and-stick-tiles",
   "/ideas/small-bathroom-storage-ideas",
   "/ideas/pendant-light-height"
  ],
  "cta": "Shop Peel & Stick Tiles",
  "primaryKeyword": "peel and stick backsplash",
  "publishedDate": "2026-10-07",
  "readMinutes": 5,
  "shard": "rooms-occasions"
 },
 {
  "nn": 162,
  "slug": "teak-shower-bench-guide",
  "title": "Teak Shower Bench: Why Teak, How to Choose, and How to Care for It",
  "description": "Why teak is the standard wood for shower benches, what to check before you buy one, the right height and size, and the simple care routine that keeps it looking good for years.",
  "cluster": "Care & Maintenance",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/shower-benches",
   "/ideas/small-bathroom-storage-ideas",
   "/ideas/wood-furniture-care"
  ],
  "cta": "Shop Shower Benches",
  "primaryKeyword": "teak shower bench",
  "publishedDate": "2026-10-07",
  "readMinutes": 5,
  "shard": "care-maintenance"
 },
 {
  "nn": 163,
  "slug": "christmas-tree-decorating-ideas",
  "title": "Christmas Tree Decorating Ideas: The Order That Always Works",
  "description": "How to decorate a Christmas tree so it looks full and intentional: the lights-ribbon-ornaments order, how many ornaments you actually need by tree height, and five theme ideas that are easy to pull off.",
  "cluster": "Rooms & Occasions",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/christmas-trees",
   "/category/ornaments",
   "/ideas/christmas-tree-decorating-ideas"
  ],
  "cta": "Shop Christmas Trees",
  "primaryKeyword": "christmas tree decorating ideas",
  "publishedDate": "2026-10-07",
  "readMinutes": 6,
  "shard": "rooms-occasions"
 },
 {
  "nn": 164,
  "slug": "how-to-arrange-bedroom-furniture",
  "title": "How to Arrange Bedroom Furniture: Layouts That Actually Work",
  "description": "Where the bed should go, how much walking space you need, nightstand and dresser placement, and three layouts for small, square, and long bedrooms — with real measurements in inches.",
  "cluster": "Rooms & Occasions",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/bedroom-sets",
   "/ideas/nightstand-height-guide",
   "/ideas/small-bedroom-ideas"
  ],
  "cta": "Shop Bedroom",
  "primaryKeyword": "how to arrange bedroom furniture",
  "publishedDate": "2026-10-07",
  "readMinutes": 6,
  "shard": "rooms-occasions"
 },
 {
  "nn": 165,
  "slug": "how-to-clean-a-jute-rug",
  "title": "How to Clean a Jute Rug (Without Ruining It)",
  "description": "Jute and water do not mix. How to vacuum, spot-clean, and deodorize a jute rug safely, what to do about spills and pet accidents, and the one mistake that ruins most jute rugs.",
  "cluster": "Care & Maintenance",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/area-rugs",
   "/ideas/wool-vs-jute-vs-synthetic-rugs",
   "/ideas/rug-care-101"
  ],
  "cta": "Shop Area Rugs",
  "primaryKeyword": "how to clean a jute rug",
  "publishedDate": "2026-10-07",
  "readMinutes": 5,
  "shard": "care-maintenance"
 },
 {
  "nn": 166,
  "slug": "dining-room-lighting-ideas",
  "title": "Dining Room Lighting Ideas: Size, Height, and Layering That Work",
  "description": "How to light a dining room: the right fixture size for your table, exact hanging heights, dimmers and bulb warmth, and how to layer pendants, sconces, and lamps.",
  "cluster": "Rooms & Occasions",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/pendant-lights",
   "/category/chandeliers",
   "/category/dining",
   "/ideas/pendant-light-height",
   "/ideas/dining-table-size-guide"
  ],
  "cta": "Shop Pendant Lights",
  "primaryKeyword": "dining room lighting ideas",
  "publishedDate": "2026-10-07",
  "readMinutes": 5,
  "shard": "rooms-occasions"
 },
 {
  "nn": 167,
  "slug": "mdf-vs-particle-board",
  "title": "MDF vs Particle Board vs Plywood: What MDF Wood Is and Which to Choose",
  "description": "What is MDF wood? MDF vs particle board vs plywood compared on strength, screws and moisture, plus what CARB Phase 2 and TSCA Title VI formaldehyde rules mean.",
  "cluster": "Materials & Quality",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/dressers",
   "/category/tv-stands",
   "/category/bookcases",
   "/category/nightstands",
   "/ideas/solid-wood-vs-veneer-vs-engineered-wood"
  ],
  "cta": "Shop Dressers",
  "primaryKeyword": "mdf vs particle board",
  "publishedDate": "2026-10-07",
  "readMinutes": 8,
  "shard": "materials-quality"
 },
 {
  "nn": 168,
  "slug": "what-is-oeko-tex-certified",
  "title": "What Is OEKO-TEX Certified? Standard 100 Explained for Bedding, Throws, and Rugs",
  "description": "What OEKO-TEX Standard 100 certified means, what it tests for, the four product classes, how it differs from organic, and how to verify a certificate.",
  "cluster": "Color, Material & Textiles",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/comforters-duvets",
   "/category/throws-blankets",
   "/category/area-rugs",
   "/ideas/sustainable-furniture-certifications"
  ],
  "cta": "Shop Comforters & Duvets",
  "primaryKeyword": "oeko-tex certified",
  "publishedDate": "2026-10-07",
  "readMinutes": 5,
  "shard": "color-material-textiles"
 },
 {
  "nn": 169,
  "slug": "what-is-rubberwood",
  "title": "What Is Rubberwood? Parawood Furniture, Hardness, and Care Explained",
  "description": "What is rubberwood (parawood, hevea wood)? How hard it is, how it compares with oak and pine, solid rubberwood vs rubberwood solids, and how to care for it.",
  "cluster": "Materials & Quality",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/dining-tables",
   "/category/dining",
   "/ideas/solid-wood-vs-veneer-vs-engineered-wood",
   "/ideas/wood-furniture-care"
  ],
  "cta": "Shop Dining Tables",
  "primaryKeyword": "what is rubberwood",
  "publishedDate": "2026-10-07",
  "readMinutes": 6,
  "shard": "materials-quality"
 },
 {
  "nn": 170,
  "slug": "acacia-wood-furniture",
  "title": "Acacia Wood Furniture: Hardness, Outdoor Use, and Care Explained",
  "description": "What is acacia wood? How hard it is, whether acacia wood is good for outdoor furniture, if it's waterproof, solid vs veneer, and how to care for it.",
  "cluster": "Materials & Quality",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/outdoor-tables",
   "/category/outdoor-chairs",
   "/category/coffee-tables",
   "/category/dining-tables",
   "/ideas/outdoor-furniture-materials"
  ],
  "cta": "Shop Outdoor Tables",
  "primaryKeyword": "acacia wood furniture",
  "publishedDate": "2026-10-07",
  "readMinutes": 7,
  "shard": "materials-quality"
 },
 {
  "nn": 171,
  "slug": "faux-leather-vs-real-leather",
  "title": "Faux Leather vs Real Leather: PU, Vegan, and Bonded Leather Explained",
  "description": "What is faux leather and vegan leather? Faux leather vs real leather compared on feel, durability and care, plus how to tell them apart and what bonded leather is.",
  "cluster": "Color, Material & Textiles",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/sofas",
   "/category/recliners",
   "/category/sectionals",
   "/category/accent-chairs",
   "/ideas/leather-grades-explained"
  ],
  "cta": "Shop Sofas",
  "primaryKeyword": "faux leather vs real leather",
  "publishedDate": "2026-10-07",
  "readMinutes": 7,
  "shard": "color-material-textiles"
 },
 {
  "nn": 172,
  "slug": "what-is-boucle-fabric",
  "title": "What Is Boucle Fabric? Materials, Durability, and Care Explained",
  "description": "What is boucle fabric? What it's made of (wool, polyester, performance), how durable it is, boucle vs sherpa, and how to clean boucle furniture.",
  "cluster": "Color, Material & Textiles",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/accent-chairs",
   "/category/sofas",
   "/category/ottomans",
   "/ideas/boucle-vs-linen-vs-performance-fabric"
  ],
  "cta": "Shop Accent Chairs",
  "primaryKeyword": "boucle fabric",
  "publishedDate": "2026-10-07",
  "readMinutes": 6,
  "shard": "color-material-textiles"
 },
 {
  "nn": 173,
  "slug": "what-is-mango-wood",
  "title": "What Is Mango Wood? Hardness, Color, and Furniture Care Explained",
  "description": "What is mango wood? Whether mango is a hardwood, how it compares with acacia and oak, what color it is, solid vs veneer, and how to care for mango wood furniture.",
  "cluster": "Materials & Quality",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/coffee-tables",
   "/category/sideboards",
   "/category/console-tables",
   "/ideas/acacia-wood-furniture"
  ],
  "cta": "Shop Coffee Tables",
  "primaryKeyword": "mango wood furniture",
  "publishedDate": "2026-10-07",
  "readMinutes": 6,
  "shard": "materials-quality"
 },
 {
  "nn": 174,
  "slug": "what-is-sintered-stone",
  "title": "What Is Sintered Stone? Table Tops, Durability, and Sintered Stone vs Quartz",
  "description": "What is sintered stone and what is it made of? How it compares with quartz and marble, whether it chips, and how to care for a sintered stone table top.",
  "cluster": "Materials & Quality",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/dining-tables",
   "/category/coffee-tables",
   "/category/outdoor-tables",
   "/ideas/marble-vs-quartz-vs-wood-dining-tabletops"
  ],
  "cta": "Shop Dining Tables",
  "primaryKeyword": "sintered stone",
  "publishedDate": "2026-10-07",
  "readMinutes": 6,
  "shard": "materials-quality"
 },
 {
  "nn": 175,
  "slug": "rattan-vs-wicker",
  "title": "Rattan vs Wicker: What's the Difference (and Where Cane Fits In)",
  "description": "Rattan vs wicker explained: what rattan is, what wicker furniture is, cane vs rattan, and which to choose indoors or for an outdoor patio.",
  "cluster": "Materials & Quality",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/outdoor-chairs",
   "/category/outdoor-sofas",
   "/category/accent-chairs",
   "/ideas/outdoor-furniture-materials"
  ],
  "cta": "Shop Outdoor Chairs",
  "primaryKeyword": "rattan vs wicker",
  "publishedDate": "2026-10-07",
  "readMinutes": 6,
  "shard": "materials-quality"
 },
 {
  "nn": 176,
  "slug": "tempered-glass-table-guide",
  "title": "Tempered Glass Tables: Are Glass Table Tops Safe, and How to Choose One",
  "description": "Are glass table tops tempered and safe? How tempered glass differs from regular glass, how to tell, what thickness you need, and how to choose a glass top dining or coffee table.",
  "cluster": "Materials & Quality",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/coffee-tables",
   "/category/dining-tables",
   "/category/console-tables",
   "/ideas/best-coffee-tables-for-small-living-rooms"
  ],
  "cta": "Shop Coffee Tables",
  "primaryKeyword": "tempered glass table",
  "publishedDate": "2026-10-07",
  "readMinutes": 6,
  "shard": "materials-quality"
 },
 {
  "nn": 177,
  "slug": "powder-coated-steel-furniture",
  "title": "Powder-Coated Steel Furniture: Does It Rust, and How to Care for It",
  "description": "What is powder coating? Does powder-coated steel rust, how it compares with paint and aluminum, and how to care for and repair powder-coated furniture.",
  "cluster": "Materials & Quality",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/outdoor-chairs",
   "/category/outdoor-tables",
   "/category/dining-chairs",
   "/ideas/outdoor-furniture-care-guide"
  ],
  "cta": "Shop Outdoor Chairs",
  "primaryKeyword": "powder coated steel",
  "publishedDate": "2026-10-07",
  "readMinutes": 6,
  "shard": "materials-quality"
 },
 {
  "nn": 178,
  "slug": "brass-vs-bronze",
  "title": "Brass vs Bronze: What Each Is Made Of, How to Tell Them Apart, and How to Care for Them",
  "description": "Brass vs bronze explained: what brass and bronze are made of, color and durability, how to tell them apart, what a brass finish means, and safe cleaning.",
  "cluster": "Materials & Quality",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/pendant-lights",
   "/category/table-lamps",
   "/category/wall-lighting",
   "/category/chandeliers",
   "/ideas/powder-coated-steel-furniture"
  ],
  "cta": "Shop Pendant Lights",
  "primaryKeyword": "brass vs bronze",
  "publishedDate": "2026-10-07",
  "readMinutes": 6,
  "shard": "materials-quality"
 },
 {
  "nn": 179,
  "slug": "what-is-polyresin",
  "title": "What Is Polyresin? Polyresin vs Polystone vs Ceramic for Sculptures and Decor",
  "description": "What polyresin is made of, whether it's plastic, how it compares with polystone and ceramic, whether it can go outside, and how to paint and care for it.",
  "cluster": "Materials & Quality",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/sculptures",
   "/category/decor",
   "/category/ornaments",
   "/ideas/how-to-style-a-bookshelf"
  ],
  "cta": "Shop Sculptures",
  "primaryKeyword": "what is polyresin",
  "publishedDate": "2026-10-07",
  "readMinutes": 5,
  "shard": "materials-quality"
 },
 {
  "nn": 180,
  "slug": "what-is-a-sherpa-blanket",
  "title": "What Is a Sherpa Blanket? Sherpa vs Fleece, How to Wash It, and How to Make It Soft Again",
  "description": "What sherpa fabric is, sherpa vs fleece and faux fur, how to wash a sherpa blanket, and how to fix matting and make a sherpa blanket soft again.",
  "cluster": "Color, Material & Textiles",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/throws-blankets",
   "/category/comforters-duvets",
   "/ideas/throw-blanket-size-guide"
  ],
  "cta": "Shop Throws & Blankets",
  "primaryKeyword": "sherpa blanket",
  "publishedDate": "2026-10-07",
  "readMinutes": 5,
  "shard": "color-material-textiles"
 },
 {
  "nn": 181,
  "slug": "lumens-vs-watts",
  "title": "Lumens vs Watts: Lumens-to-Watts Chart and How Many Lumens You Need per Room",
  "description": "Lumens vs watts explained, with a lumens-to-watts chart, how many lumens a 60 W or 100 W bulb gives, fixture max wattage, and lumens per room.",
  "cluster": "Sizing Guides",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
   "/category/table-lamps",
   "/category/floor-lamps",
   "/category/pendant-lights",
   "/category/wall-lighting",
   "/ideas/pendant-light-height"
  ],
  "cta": "Shop Table Lamps",
  "primaryKeyword": "lumens vs watts",
  "publishedDate": "2026-10-07",
  "readMinutes": 6,
  "shard": "sizing-guides"
 }
,
 {
  "nn": 182,
  "slug": "velvet-fabric-guide",
  "title": "Velvet Fabric Guide: Types, Durability, and How to Clean a Velvet Sofa",
  "description": "What velvet is, cotton vs polyester vs performance velvet, rub counts, crushing and pile marks, and how to clean and care for velvet furniture.",
  "cluster": "Color, Material & Textiles",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
    "/category/sofas",
    "/category/accent-chairs",
    "/ideas/boucle-vs-linen-vs-performance-fabric",
    "/ideas/martindale-rub-count-explained",
    "/ideas/what-is-boucle-fabric"
 ],
  "cta": "Shop Sofas",
  "primaryKeyword": "velvet fabric",
  "publishedDate": "2026-10-07",
  "readMinutes": 6,
  "shard": "color-material-textiles"
 },
 {
  "nn": 183,
  "slug": "ceramic-vs-porcelain",
  "title": "Ceramic vs Porcelain: What's the Difference for Vases, Tiles, and Tableware?",
  "description": "Ceramic vs porcelain explained: how each is made, which is stronger, water absorption, and which to choose for vases, planters, tiles, and dinnerware.",
  "cluster": "Materials & Quality",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
    "/category/vases",
    "/ideas/vase-size-guide",
    "/ideas/how-to-decorate-with-sculptures",
    "/ideas/what-is-polyresin"
 ],
  "cta": "Shop Vases",
  "primaryKeyword": "ceramic vs porcelain",
  "publishedDate": "2026-10-07",
  "readMinutes": 5,
  "shard": "color-material-textiles"
 }
,
 {
  "nn": 184,
  "slug": "jute-vs-sisal-vs-seagrass-rugs",
  "title": "Jute vs Sisal vs Seagrass Rugs: Softness, Durability, and Where Each Belongs",
  "description": "Jute vs sisal vs seagrass compared: how each natural-fiber rug feels underfoot, how it wears, how it handles spills, and which room suits it.",
  "cluster": "Color, Material & Textiles",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
    "/category/area-rugs",
    "/ideas/how-to-clean-a-jute-rug",
    "/ideas/wool-vs-jute-vs-synthetic-rugs"
 ],
  "cta": "Shop Area Rugs",
  "primaryKeyword": "jute vs sisal",
  "publishedDate": "2026-10-07",
  "readMinutes": 5,
  "shard": "color-material-textiles"
 },
 {
  "nn": 185,
  "slug": "coir-doormat-guide",
  "title": "Coir Doormats: What Coir Is, How Long It Lasts, and How to Clean One",
  "description": "What a coir doormat is made of, why coconut fiber scrapes shoes clean, how long it lasts outdoors, and simple ways to clean and refresh it.",
  "cluster": "Materials & Quality",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
    "/category/doormats",
    "/ideas/doormat-size-guide"
 ],
  "cta": "Shop Doormats",
  "primaryKeyword": "coir doormat",
  "publishedDate": "2026-10-07",
  "readMinutes": 4,
  "shard": "materials-quality"
 }
,
 {
  "nn": 186,
  "slug": "wool-rug-guide",
  "title": "Wool Rugs: Why They Cost More, How Long They Last, and How to Clean One",
  "description": "What makes a wool rug worth the price: how wool wears, why new rugs shed, how to clean a wool rug safely, and when to choose something else.",
  "cluster": "Color, Material & Textiles",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
    "/category/area-rugs",
    "/ideas/jute-vs-sisal-vs-seagrass-rugs",
    "/ideas/wool-vs-jute-vs-synthetic-rugs"
 ],
  "cta": "Shop Area Rugs",
  "primaryKeyword": "wool rug",
  "publishedDate": "2026-10-07",
  "readMinutes": 5,
  "shard": "color-material-textiles"
 },
 {
  "nn": 188,
  "slug": "linen-vs-cotton-sheets",
  "title": "Linen vs Cotton Sheets: Feel, Breathability, Wrinkles, and Which to Buy",
  "description": "Linen vs cotton sheets compared honestly: how each feels, how they handle heat, why linen wrinkles, what they cost, and who should pick which.",
  "cluster": "Color, Material & Textiles",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
    "/category/comforters-duvets",
    "/ideas/duvet-vs-comforter",
    "/ideas/what-is-oeko-tex-certified"
 ],
  "cta": "Shop Comforters & Duvets",
  "primaryKeyword": "linen vs cotton sheets",
  "publishedDate": "2026-10-07",
  "readMinutes": 5,
  "shard": "color-material-textiles"
 },
 {
  "nn": 189,
  "slug": "blackout-curtains-guide",
  "title": "Blackout Curtains: How They Work, Blackout vs Room Darkening, and How to Hang Them",
  "description": "What blackout curtains actually block, the difference between blackout and room darkening, whether they help with heat, and how to hang them for a true dark room.",
  "cluster": "Sizing Guides",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
    "/category/curtains-drapes",
    "/ideas/curtain-size-guide",
    "/ideas/curtain-size-guide"
 ],
  "cta": "Shop Curtains & Drapes",
  "primaryKeyword": "blackout curtains",
  "publishedDate": "2026-10-07",
  "readMinutes": 5,
  "shard": "sizing-guides"
 }
,
 {
  "nn": 190,
  "slug": "how-to-wash-bath-mats",
  "title": "How to Wash Bath Mats (Cotton, Memory Foam, and Rubber-Backed)",
  "description": "How to wash bath mats the right way: machine settings by mat type, how often to wash, drying without ruining the backing, and when to replace.",
  "cluster": "Materials & Quality",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
    "/category/bath-rugs",
    "/ideas/how-to-clean-a-jute-rug",
    "/ideas/coir-doormat-guide"
 ],
  "cta": "Shop Bath Rugs",
  "primaryKeyword": "how to wash bath mats",
  "publishedDate": "2026-10-07",
  "readMinutes": 4,
  "shard": "materials-quality"
 },
 {
  "nn": 191,
  "slug": "soy-vs-paraffin-candles",
  "title": "Soy vs Paraffin Candles: What Candle Wax Is Made Of and How It Burns",
  "description": "Soy vs paraffin candles compared: what candle wax is made of, scent throw, burn time, soot, beeswax and blends, and how to burn any candle cleanly.",
  "cluster": "Materials & Quality",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
    "/category/candles",
    "/ideas/how-to-style-a-bookshelf",
    "/ideas/how-to-style-a-coffee-table"
 ],
  "cta": "Shop Candles",
  "primaryKeyword": "soy vs paraffin candles",
  "publishedDate": "2026-10-07",
  "readMinutes": 5,
  "shard": "materials-quality"
 }
,
 {
  "nn": 192,
  "slug": "porch-light-guide",
  "title": "Porch Lights: Size, Height, Brightness, and What Porch Light Colors Mean",
  "description": "A practical porch light guide: what size fixture to choose, how high to mount it, how bright it should be, wet vs damp ratings, and what green, blue, and purple porch lights mean.",
  "cluster": "Sizing Guides",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
    "/category/outdoor-hanging-lights",
    "/category/wall-lighting",
    "/ideas/lumens-vs-watts"
 ],
  "cta": "Shop Outdoor Hanging Lights",
  "primaryKeyword": "porch lights",
  "publishedDate": "2026-10-07",
  "readMinutes": 5,
  "shard": "sizing-guides"
 },
 {
  "nn": 193,
  "slug": "how-to-store-christmas-ornaments",
  "title": "How to Store Christmas Ornaments So They Survive Every Year",
  "description": "How to store Christmas ornaments safely: sorting, wrapping glass and handmade pieces, choosing ornament storage, and where to keep the boxes.",
  "cluster": "Materials & Quality",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
    "/category/ornaments",
    "/ideas/christmas-tree-decorating-ideas",
    "/ideas/christmas-tree-size-guide"
 ],
  "cta": "Shop Ornaments",
  "primaryKeyword": "how to store christmas ornaments",
  "publishedDate": "2026-10-07",
  "readMinutes": 4,
  "shard": "materials-quality"
 }
,
 {
  "nn": 194,
  "slug": "how-to-hang-a-picture",
  "title": "How to Hang a Picture: Height, Hardware, and Hanging Frames Without Nails",
  "description": "How to hang a picture straight the first time: how high to hang pictures, the right hardware for drywall and plaster, wire vs sawtooth hangers, and nail-free options.",
  "cluster": "Sizing Guides",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
    "/category/picture-frames",
    "/ideas/picture-frame-sizes",
    "/ideas/how-to-plan-and-hang-a-gallery-wall"
 ],
  "cta": "Shop Picture Frames",
  "primaryKeyword": "how to hang a picture",
  "publishedDate": "2026-10-07",
  "readMinutes": 5,
  "shard": "sizing-guides"
 },
 {
  "nn": 195,
  "slug": "bathroom-vanity-lighting-guide",
  "title": "Bathroom Vanity Lights: Placement, Size, and Brightness for a Flattering Mirror",
  "description": "How to choose bathroom vanity lights: side sconces vs a bar above the mirror, mounting height, fixture width, brightness, color temperature, and damp ratings.",
  "cluster": "Sizing Guides",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
    "/category/wall-lighting",
    "/ideas/wall-sconce-height-guide",
    "/ideas/lumens-vs-watts"
 ],
  "cta": "Shop Wall Lighting",
  "primaryKeyword": "bathroom vanity lights",
  "publishedDate": "2026-10-07",
  "readMinutes": 5,
  "shard": "sizing-guides"
 }
,
 {
  "nn": 196,
  "slug": "how-to-clean-a-chandelier",
  "title": "How to Clean a Chandelier (Including Crystal Chandeliers)",
  "description": "How to clean a chandelier safely: power-off prep, dusting vs deep cleaning, how to clean a crystal chandelier, and what to avoid on metal finishes.",
  "cluster": "Materials & Quality",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
    "/category/chandeliers",
    "/ideas/chandelier-size-guide",
    "/ideas/brass-vs-bronze"
 ],
  "cta": "Shop Chandeliers",
  "primaryKeyword": "how to clean a chandelier",
  "publishedDate": "2026-10-07",
  "readMinutes": 5,
  "shard": "materials-quality"
 },
 {
  "nn": 197,
  "slug": "how-to-wash-blankets",
  "title": "How to Wash Blankets: Wool, Fleece, Knit, and Throws Without Ruining Them",
  "description": "How to wash blankets by fabric: machine settings for cotton, fleece, and sherpa, how to wash a wool blanket, drying tips, and how to prevent pilling on blankets.",
  "cluster": "Color, Material & Textiles",
  "hero": null,
  "schema": "Article + FAQPage",
  "internalLinks": [
    "/category/throws-blankets",
    "/ideas/what-is-a-sherpa-blanket",
    "/ideas/throw-blanket-size-guide"
 ],
  "cta": "Shop Throws & Blankets",
  "primaryKeyword": "how to wash blankets",
  "publishedDate": "2026-10-07",
  "readMinutes": 5,
  "shard": "color-material-textiles"
 }
];

export const JOURNAL_SLUGS: Set<string> = new Set(JOURNAL_ARTICLES.map((a) => a.slug));

export function getArticleBySlug(slug: string): JournalArticleMeta | undefined {
  return JOURNAL_ARTICLES.find((a) => a.slug === slug);
}

type Shard = Record<string, { body: string; mids: string[] }>;
const shardCache = new Map<string, Promise<Shard | null>>();

function loadShard(shard: string): Promise<Shard | null> {
  if (!shardCache.has(shard)) {
    shardCache.set(
      shard,
      fetch(`/journal-data/${shard}.json`)
        .then((r) => (r.ok ? (r.json() as Promise<Shard>) : null))
        .catch(() => null),
    );
  }
  return shardCache.get(shard)!;
}

export async function loadArticleBody(slug: string): Promise<JournalArticleBody | null> {
  const meta = getArticleBySlug(slug);
  if (!meta) return null;
  const data = await loadShard(meta.shard);
  const entry = data?.[slug];
  if (!entry) return null;
  return { slug, body: entry.body, mids: entry.mids };
}
